/* eslint-disable max-len */
module.exports = {
  aOfB: '{a} из {b}',
  about: 'Сведения',
  aboutThisItem: 'Информация о продукте',
  accessApiKeyManager: 'Получить доступ к Диспетчеру ключа API для этого участника.',
  accessControls: 'Настройки Управления Доступом',
  accessControlsCopiedText: 'Настройки управления доступом автоматически обновлены. Авторизация медиабезопасности будет обновлена в течение нескольких минут.',
  accessControlsCopiedTitle: 'Настройки управления доступом успешно скопированы',
  accessControlsCopyConfirmation: 'Данная операция удалит все существующие настройки управления доступом из {to} и заменит их на настройки управления доступом из {from}. Данную операцию нельзя отменить.',
  accessControlsDescription: 'Настройки управления доступом определяют, кто может видеть медиа, основываясь на выбранных Организациях и Категориях Медиа.',
  accessControlsHelpText: 'Настраивайте управление доступом для этой организации. Пользователи могут получить доступ только к тем медиафайлам, на просмотр которых у них есть разрешения в соответствующих категориях. Применение нескольких медиафайлов к организации может занять некоторое время. Подождите, пока изменения вступят в силу, и при необходимости воспользуйтесь кнопкой обновления страницы.',
  accessControlsIndeterminance: 'Примечание: Вышестоящие организации всегда имеют доступ к контенту, присвоенному к любой их дочерней организации.',
  accessControlsRefreshWarning: 'У вас имеются несохраненные изменения. При обновлении страницы они будут удалены. Продолжить?',
  accessControlsSaveSuccess: 'Настройки управления доступом сохранены.',
  accessControlsTitleSection: 'Когда к этой организации применяются настройки управления доступом, они также автоматически передаются следующим организациям путем обратного наследования:',
  accessControlsTooltip: 'Организации также получают доступ к контенту, который доступен их дочерним организациям. Приведенная ниже сетка не включает контент, к которому эта организация получила доступ через подразумеваемую передачу доступа вверх по иерархии или через обратное наследование.',
  account: 'Учетная запись',
  accountErrorMessage: 'Сообщение об ошибке учетной записи',
  accountErrorMessageWarning: 'В поле accountErrorMessage базы данных для участника будет установлено значение «Несанкционированный».',
  action: 'Действие | Действия',
  actionDelete: 'удалить',
  actionLoad: 'загрузить',
  actionPaste: 'Вставить',
  actionRun: 'запустить',
  actionSave: 'Сохранить',
  actionUndoWarning: 'Данную операцию нельзя отменить.',
  actionUpload: 'загрузить',
  actualSize: 'Фактический Размер',
  add: 'Добавить',
  addABookText: 'Добавить книгу',
  addABookToStart: '{addABookText}, чтобы начать.',
  addAForm: 'Добавьте Форму, чтобы начать',
  addAFormOnly: 'Добавить форму',
  addAMedia: 'Добавить медиафайл',
  addAPIKey: 'Добавить Ключ API',
  addAPartCollection: 'Добавьте {partCollection}, чтобы начать.',
  addAPrintSettingText: 'Добавить Настройки Печати',
  addAPrintSettingToStart: '{addAPrintSettingText}, чтобы начать.',
  addASharedCart: 'Добавить совместную корзину',
  addATag: 'Добавить тег',
  addATemplate: 'Добавить шаблон',
  addAllPartsCart: 'Добавить все детали в корзину',
  addAnOrderQuoteEmailFormat: 'Добавить формат электронного сообщения о заказе/коммерческом предложении',
  addBooks: 'Добавить Книги',
  addBrowseFlow: 'Добавить Просмотр Потоков',
  addChapter: 'Добавить Раздел',
  addChildBrowseFlow: 'Добавить Просмотр Дочерних Потоков',
  addComment: 'Добавить комментарий',
  addExistingPart: 'Добавить Существующую Деталь',
  addGroupsToUsers: 'Добавить группы {groups} к пользователям {users}',
  addItem: 'Добавить {item}',
  addMedia: 'Добавить Медиа',
  addPages: 'Добавить Страницы',
  addPart: 'Добавить Деталь',
  addReports: 'Добавить Отчеты',
  addRootBrowseFlow: 'Добавить Просмотр Корневого Потока',
  addRow: 'Добавить строку',
  addTemplates: 'Добавить шаблоны',
  addToCartMessage: 'Успешно добавлено {partNumber}',
  addToUserGroup: 'Добавить в Группы',
  addWidgetKey: 'Добавить ключ виджета',
  addedOn: 'Добавлено',
  additionalInformation: 'Дополнительная Информация',
  additionalNotification: 'Дополнительное Уведомление',
  additionalPartNumberDescription: 'Использовать как дополнительное поле номера детали',
  address: 'Адрес | Адреса',
  addressInUse: 'Адрес установлен как исходный и не может быть удален',
  addressInUseSubtitle: 'Чтобы удалить этот адрес, вам нужно сперва удалить его как адрес по умолчанию.',
  addressLine: 'Строка адреса {number}',
  addressState: {
    confirmationMessage: 'Следующие адреса не подтверждены.',
    confirmationTitle: 'Продолжить роботу с неподтвержденными адресами?',
    disabledVerification: 'При отправке заказа / коммерческого предложения подтверждение адреса для этого поля будет отключено',
    enteredAddress: 'Введенный адрес',
    failedToFetchSuggestions: 'Не удалось получить рекомендуемые адреса.',
    failedToLoadDetails: 'Не удалось загрузить сведения об адресе.',
    incomplete: 'Неполный адрес',
    missingSubpremise: 'Дополнительные адресные данные отсутствуют',
    noSuggestions: 'Рекомендаций не найдено. Чтобы получить рекомендации, отредактируйте адрес.',
    selectAddress: '(выберите один вариант)',
    subpremiseMessage: 'По всей видимости, этот адрес относится к жилому или офисному зданию. Укажите полный адрес, добавив номер квартиры, комнаты или помещения.',
    suggested: 'Рекомендуемые адреса',
    unverified: 'Неподтвержденный адрес',
    unverifiedHelpText: 'Выберите другой сохраненный адрес, отредактируйте этот или добавьте новый',
    unverifiedMessage: 'Мы не можем подтвердить этот адрес для доставки.',
    verified: 'Подтвержденный адрес'
  },
  admin: 'Администратор',
  adminCenter: 'Центр Администратора',
  adminCenterBanner: {
    bodyLabel: 'Тело баннера',
    enableLabel: 'Включить баннер администратора',
    headerGreenOption: 'Зеленый',
    headerLabel: 'Название баннера',
    headerRedOption: 'Красный',
    headerYellowOption: 'Желтый',
    title: 'Баннер центра администрирования',
    typeLabel: 'Тип баннера'
  },
  adminCenterMessage: 'Центр администратора для контента, пользователей, настроек библиотеки, отчетов и экспорта',
  adminMessage: 'Функции добавляются по мере их доступности',
  administration: 'Администрация',
  advancedFilters: 'Расширенные фильтры',
  affectedBookMedia: 'Такое количество медиа‑книг будет обновлено: {count}.',
  affectedProductPages: '{count} стр. продуктов будут обновлены.',
  affectedTemplateMedia: 'Такое количество шаблонов книг будет обновлено: {count}.',
  after: 'После',
  aggregatedFromChildren: 'Агрегировано из Дочерних',
  aiAlgorithm: 'Сканер на основе ИИ',
  algorithm: 'Алгоритм',
  alignHorizontal: 'Выравнивание По Горизонтали',
  alignVertical: 'Выравнивание По Вертикали',
  all: 'Все',
  allLibraryPages: 'Все страницы библиотеки',
  allPagesAndBooks: 'Все страницы и книги',
  allUsersDisabled: 'Все пользователи, принадлежащие участнику, будут отключены.',
  alphanumeric: 'Алфавитно-цифровой',
  analyticsJSON: 'JSON-файл аналитики',
  andCountMore: 'и еще {count}…',
  announcement: 'Объявление | Объявления',
  any: 'Любой',
  apiAuthHeader: 'Заголовок Авторизации API',
  apiKey: 'Ключ API | Ключи API',
  apiKeyAdmin: 'Ключ API Администратора',
  apiKeyCopied: 'Значение Заголовка Авторизации API скопировано в Буфер Обмена',
  apiKeyDeleteMsg: 'Удаление этого Ключа API отключит его применение интеграциями',
  apiKeyDeleteTitle: 'Удалить этот Ключ API?',
  apiKeyDeleted: 'Ключ API удален',
  apiKeyDeletedError: 'Ошибка удаления Ключа API',
  apiKeyInstructions: 'Ключ будет создан при Сохранении',
  apiKeyManager: 'Диспетчер Ключа API',
  apiKeyNameEmpty: 'Поле имени не должно быть пустым',
  apiKeyRegenError: 'Ошибка повторного создания Ключа API',
  apiKeyRegenMsg: 'Повторное создание Ключа API может привести к отключению существующих интеграций',
  apiKeyRegenTitle: 'Создать этот Ключ API повторно?',
  apiKeySaved: 'Ключ API Сохранен',
  apiKeyType: 'Тип ключа API',
  appliesTo: 'Применимо к',
  appliesToEmpty: 'Затребовать хотя бы один выбранный тип объекта',
  appliesToPopulated: 'Установить, к каким объектам может быть применен тег',
  apply: 'Применить',
  applyItem: 'Применить {item}',
  applyToChildItems: 'Применить к дочернему {item}',
  applyToPartOnly: 'Применить только к этой детали',
  april: 'Апрель',
  areYouSure: 'Вы уверены, что хотите удалить {item}?',
  areYouSureCopy: 'Вы уверены, что хотите скопировать {item}?',
  areYouSureYouWantToDisableTheTenant: 'Действительно отключить участника?',
  area: 'Зона',
  assembly: 'Сборка | Сборки',
  assemblyConfirmationTitle: 'Вы хотите завершить создание сборки?',
  assemblyCreatorHelpText1: 'Эта функция позволяет вставить выбранную страницу в книги везде, где название {partName} этой детали будет найдено, автоматически соединяя деталь и выбранную страницу через ссылку-якорь. Вы можете опционально ограничить ссылку только выбранными книгами.',
  assemblyCreatorHelpText2: 'Выбранная страница будет вставлена единожды в каждую книгу после первого появления {partName}.',
  assemblyCreatorSuccessSubtitle: 'Изменения в ссылках на основные точки и оглавлении книги будут применены немедленно. Результаты поиска будут отображены после завершения индексации.',
  assemblyCreatorSuccessTitle: 'Задание на создание сборки отправлено',
  assemblyStepOne: 'Шаг 1: Выберите страницу, которую нужно вставить',
  assemblyStepTwo: 'Шаг 2: Выберите книги, в которые нужно вставить страницу',
  asset: 'Ресурс | Ресурсы',
  assetsNotFound: 'Тип {type} Не найден',
  assignBrowseFlow: 'Назначить Просмотр Потока',
  assignMedia: 'Назначить медиафайл',
  assignMediaToItem: 'Назначьте медиафайл этому {item}.',
  assignedOrganizations: 'Назначить Организации',
  associateProductPage: 'Связать существующую страницу продукта',
  associateProductPageDescription: 'Свяжите страницы продуктов с этим медиафайлом.',
  associateProductPageTip: 'Совет. Если нужного продукта еще нет в списке, вы можете добавить его, нажав «Создать новую страницу продукта» (она откроется в новой вкладке). Вам все равно потребуется вернуться на эту страницу, чтобы привязать страницу нового продукта после ее создания.',
  associateProducts: 'Связанные продукты',
  atLeastFiveError: 'Выберите значение не меньше 5.',
  attachRelatedPDFs: 'Вставить PDF-файлы страниц соответствующих деталей',
  attachment: 'Вложение | Вложения',
  attachmentEditorDescription: 'Прикрепите изображения, видео и документы непосредственно к этому объекту. Примечание: их можно найти во вкладке «Похожее».',
  attachmentEditorDescriptionPP: 'Прикрепите изображения, видео и документы непосредственно к этому объекту.',
  attachmentFileUploadSizeError: 'Размер файла превышает лимит в 50 МБ',
  attachmentView: 'Просмотреть Вложенное',
  attributions: 'Атрибуты',
  august: 'Август',
  autoHideEmptyCards: 'Автоматически скрывать пустые карты',
  autoHotpoint: 'Автоматическая Центральная Точка',
  autoPopulate: 'Автоматическое Наполнение',
  automaticZoom: 'Автоматическое Масштабирование',
  availability: 'Доступность',
  back: 'Назад',
  backCover: 'Тыльная сторона Обложки',
  backStitch: 'Задний Шов',
  backToLibrary: 'Назад в Библиотеку',
  backToSearch: 'Вернуться к Поиску',
  badCredentials: 'Неверные Учетные данные',
  badDefaultValueMessage: 'Значение по умолчанию должно быть в диапазоне от {min} до {max} симв.',
  bahasaDescription: 'Описание На Индонезийском',
  bahasaName: 'Название На Индонезийском',
  banner: 'Баннер',
  banners: 'Баннеры',
  barColor: 'Цвет панели',
  before: 'До',
  beginTypingToFindAnything: 'Начните вводить для поиска',
  beta: 'Бета',
  betaAccessKeys: 'Ключи доступа к бета-версии',
  betaReleaseVideo: 'Видео Бета-версии',
  betaResources: 'Бета-ресурсы',
  blobFinder: 'Система поиска BLOB',
  body: 'Текстовый блок',
  bom: 'Спецификация',
  bomDefaultSupplier: 'Поставщик спецификации по умолчанию',
  bomExportSuccess: 'Экспорт спецификации выполнен успешно',
  bomItem: 'Номенклатура Спецификации',
  bomItems: 'Элементы спецификации',
  bomLayout: 'Макет Перечня Материалов',
  bomListOptions: 'Опции Списка Спецификаций',
  bomListSettings: 'Настройки Списка Спецификаций',
  book: 'Книга | Книги',
  bookInserts: 'Содержание книги',
  bookLabel: 'Книга | Книги',
  bookPrintingDisable: 'Запретить Печать Книги',
  booksAndPagesDisplay: 'Отображение Книг и Страниц',
  boost: 'Ускорение Поиска',
  boostDescription: 'Добавить значение больше 1,5 для повышения актуальности поиска этого тега над номерами запчастей, идентификаторами медиа и именами',
  boostRangeInvalid: 'Показатель увеличения должен быть в диапазоне от 0,5 до 100,0',
  border: 'Граница',
  both: 'Оба',
  bottom: 'Низ',
  branding: 'Брендинг',
  browse: 'Просмотреть',
  browseComputer: 'Просмотр файлов на Компьютере',
  browseFlow: 'Галерея Просмотра| Галереи Просмотра',
  browseFlowAssigned: 'Просмотр Указанного Потока',
  browseFlowCopyMessage: 'Введите уникальное имя для Просмотра Потока.',
  browseFlowDeleteMessage: 'Удаление просмотра потока удаляет не только поток, но и все дочерние потоки.',
  browseFlowDeleted: 'Просмотреть удаленные потоки',
  browseFlowEmptyState: 'Просмотр Потока Не указан. {new}, чтобы начать.',
  browseFlowHierarchy: 'Иерархия просмотра потока',
  browseFlowMediaCategoryProductPageHelpText: 'Удалите текущий критерий поиска «Тип: страница продукта», чтобы применить изменения',
  browseFlowMoveToRoot: 'Переместите узел сюда, чтобы установить дочернюю ветку первого уровня',
  browseFlowNoAssignedOrgs: 'Нет назначенных организаций',
  browseFlowNoExistingCriteria: 'Критерии поиска не были указаны для этого просмотра потока.  Используйте элементы управление выше, чтобы выбрать критерии поиска',
  browseFlowNoExistingCriteriaBelow: 'Для этого потока просмотра не указаны критерии поиска.  Воспользуйтесь элементами управления ниже, чтобы выбрать их.',
  browseFlowSaveFailed: 'Просмотр Потока не удалось обновить',
  browseFlowSaved: 'Просмотр Потока сохранен',
  browseFlowSelectionRequired: 'Необходимо выбрать поток просмотра.',
  browseFlowSetDefaultSuccess: 'Установлен Просмотр Потока по умолчанию',
  browseFlowThumbnailDeleteFailTitle: 'Не удалось Удалить Миниатюру',
  browseFlowThumbnailDeleteSuccessTitle: 'Миниатюра Успешно Удалена',
  browseFlowThumbnailUploadFailTitle: 'Не удалось Загрузить Миниатюру',
  browseFlowThumbnailUploadSuccessTitle: 'Миниатюра Успешно Загружена',
  browseFlowTooManyOrgs: 'У вас слишком много организаций для использования текущего редактора галереи просмотра. Пожалуйста, свяжитесь с Центром поддержки Documoto по адресу {email}, чтобы получить помощь с редактированием галереи просмотра Documoto.',
  browserDeprecation: {
    text: 'В свете того, что Microsoft перестает поддерживать обновление браузера Internet Explorer (все версии), а также из-за других соображений безопасности мы не будем в дальнейшем поддерживать доступ пользователей через Internet Explorer (все версии) после 30 сентября 2021 года.',
    title: 'Уведомление об Устаревшем Браузере'
  },
  browserPartiallySupport: 'В этом браузере вы можете заметить отличия эстетического характера и другие изменения.',
  buildHotpointLinks: 'Создание Ссылок-якорей',
  buildHotpointLinksInfo: 'Это действие сначала удалит все существующие ссылки-якоря из страниц книг, а потом создаст новые ссылки-якоря между деталями и подходящими страницами сборки.',
  buildHotpointLinksTitle: 'Вы хотите создать ссылки-якоря для этой книги?',
  bulkApplyAllOrgs: 'Массово применить ко всем организациям',
  bulkApplyAllOrgsModalMsg: 'Применить доступ к этому контенту ко всем организациям? Нажав кнопку «Подтвердить», вы сразу же предоставите доступ всем организациям, и изменения в настройках управления доступом будут сохранены.',
  bulkExportConfirm: 'Вы хотите экспортировать {n} {unit}?',
  bulkExportLimit: 'Лимит составляет {limit} книг(и) на один экспорт',
  bulkImport: 'Массовый импорт',
  bulkIndexingLane: 'Дорожка пакетного индексирования',
  bulkInsert: 'Массовая Вставка',
  bulkPageInsertJob: 'Объемная Вставка Страниц',
  bulkRemoveAllOrgs: 'Массово удалить из всех организаций',
  bulkRemoveAllOrgsModalMsg: 'Удалить доступ к этому контенту из всех организаций? Нажав кнопку «Подтвердить», вы сразу же удалите доступ из всех организаций, и изменения в настройках управления доступом будут сохранены.',
  business: 'Бизнес',
  button: 'Кнопка',
  cameraSettings: 'Параметры камеры',
  cancel: 'Отменить',
  cancelAssemblyCreatorSubtitle: 'Задание по созданию сборки не будет обработано.',
  cancelAssemblyCreatorTitle: 'Удалить задание по созданию сборки?',
  canceled: 'Отменено',
  cannotExceed100: 'Не может превышать 100 %',
  cannyWidgetLoadFailure: 'Не удалось загрузить форум отзывов',
  cart: 'Корзина | Корзины',
  cartBehaviorDisabled: 'Запретить Подсказку о Количестве Добавленного в Корзину',
  cartBehaviorEnabled: 'Разрешить Подсказку о Количестве Добавленного в Корзину',
  cartBehaviorLabel: 'Поведение для Количества Добавленного в Корзину',
  cartColumn: 'Колонка Корзины | Колонки Корзины',
  cartColumn1: '1-я Колонка Цены Корзины',
  cartColumn2: '2-я Колонка Цены Корзины',
  cartColumn3: '3-я Колонка Цены Корзины',
  cartColumnPartLocationContent1: 'Включение этой функции будет иметь следующие последствия:',
  cartColumnPartLocationContent2: 'Уникальная строка детали в корзине также будет основываться на ее местоположении в контенте, если такой способ можно применить.',
  cartColumnPartLocationContent3: 'Эти настройки нельзя отключить на уровне организации, и они будут применены ко всем пользователям.',
  cartColumnPartLocationContent4: 'Эти настройки не стоит включать, если у вас есть интеграция Отправить Корзину. Для этого необходимо связаться с вашим Менеджером по Сопровождению Клиентов Documoto.',
  cartColumnPartLocationOption: 'Включить Данные Местоположения Детали в Корзине',
  cartColumnPartLocationTitle: 'Вы уверены, что хотите включить Данные Местоположения Детали в Корзине?',
  cartDisable: 'Отключить Корзину ',
  cartEmailFailed: 'Ошибка сообщения электронной почты корзины',
  cartEmailSent: 'Сообщение электронной почты корзины отправлено',
  cartEnable: 'Включить Корзину ',
  cartErpMessage: 'Успешно отправлено в ERP',
  cartImportError: 'Ошибка при импорте корзины',
  cartLoadedWithItemsRemoved: '{count} ед. номенклатуры удалена (-но), потому что в данный момент у вас нет разрешения на ее (их) заказ',
  cartSaveEnable: 'Включить Сохранение Корзины',
  cartSharedAddEdit: 'Добавить / Редактировать Совместные Корзины',
  cartUpdated: 'Корзина Обновлена',
  cartUpdatedAndRemovedCount: 'Корзина Обновлена; удалено {count} деталей, которые нельзя заказать',
  category: 'Категория | Категории',
  categoryCreated: 'Категория Создана',
  categoryNotFoundError: '403 — категория объекта не найдена',
  categoryUpdated: 'Категория Обновлена',
  centimeter: 'Сантиметр| Сантиметры',
  changeNotification: 'Уведомление Об Изменении',
  changeScope: '{n} {type} будет затронут',
  changeUserOrganization: 'Изменить Организацию',
  chapter: 'Глава | Главы',
  chapterHeader: 'Заголовок Главы',
  chaptersOnly: 'Только Главы',
  charLimitHelpText: 'Введите от {min} до {max} симв.',
  chineseDescription: 'Описание На Китайском',
  chineseName: 'Название На Китайском',
  circle: 'Круг',
  city: 'Город',
  className: 'Название класса',
  classicAdminMessage: 'Вы будете направлены обратно в Flex, чтобы воспользоваться модулями администратора.',
  classicAdmins: 'Классические Администраторы',
  classicExporter: 'Классический Экспортер',
  classicExporterMessage: 'Модуль прежней версии на базе Flash для экспорта контента',
  classicOrganizationAdmin: 'Классический Администратор Организации',
  classicOrganizationAdminMessage: 'Модуль управления пользователями прежней версии на базе Flash для управления организациями и пользователями',
  classicPublisher: 'Классический Публикатор',
  classicPublisherMessage: 'Модуль публикации прежней версии на базе Flash для создания контента и настроек печати',
  classicReporting: 'Классический Отчет',
  classicReportingMessage: 'Модуль прежней версии на базе Flash для отчетов',
  classicTenantAdmin: 'Классический Администратор Клиента',
  classicTenantAdminMessage: 'Административный модуль прежней версии на базе Flash для клиентских настроек',
  clear: 'Очистить',
  clearFilters: 'Очистить Фильтры',
  clearHotpoints: 'Очистить основные точки',
  clearItemNumber: 'Удалить номер товара',
  clearItemNumberMessage: 'Удаление номера товара приведет к удалению следующих данных:',
  clearItemNumberTitle: 'Удалить номер товара?',
  clearSearch: 'Очистить Историю Поиска',
  clickAction: 'Действие при нажатии',
  clickHereToUpload: 'Перенесите файл или нажмите, чтобы загрузить перезапись.',
  clickMagnifyingGlass: 'Нажмите увеличительное стекло, чтобы перейти к расширенному поиску.',
  clickOkToContinue: 'Нажмите OK, чтобы продолжить.',
  clickToDownload: 'Нажмите для Загрузки',
  clickToEnlarge: 'Нажмите, чтобы увеличить',
  clickToOpen: 'Нажмите, чтобы Открыть',
  clipboard: 'Буфер Для Обмена Данными',
  clipboardAccessError: 'Измените настройки браузера, чтобы разрешить доступ к Буферу Обмена Данными',
  close: 'Закрыть',
  closed: 'Закрыто',
  collapseAll: 'Свернуть Все',
  color: 'Цвет | Цвета',
  column: 'Колонка | Столбцы',
  columnItemType: {
    customText: 'Индивидуальный Текст',
    documentTitle: 'Название Документа',
    horizontalLine: 'Горизонтальная Линия',
    pageName: 'Название Страницы',
    pageNumber: 'Номер Страницы',
    printDate: 'Дата Печати',
    tenantName: 'Имя Участника',
    userName: 'Имя Пользователя'
  },
  columnMapping: 'Сопоставление столбцов',
  columnName: 'Название Колонки',
  combinedPage: 'Комбинированная Страница',
  combinedPageMessage: 'Диаграмма сверху, список деталей снизу',
  comingSoon: 'Ожидается',
  commaDelimited: 'с разделителями-запятыми',
  comment: 'Комментарий | Комментарии',
  commentAdded: 'Комментарий добавлен',
  commentCannotBeEmpty: 'Комментарий не может быть пустым',
  commentDeleted: 'Комментарий удален',
  commentEdit: 'Добавить / Редактировать Комментарий',
  commentEditAll: 'Редактировать Все Комментарии',
  commentUpdated: 'Комментарий обновлен',
  commentView: 'Посмотреть Комментарии',
  commerceSystem: 'Торговая Система',
  completed: 'Завершено',
  configuration: 'Конфигурация | Конфигурации',
  confirm: 'Подтвердить',
  confirmBrowseFlowApplyToChildren: 'Вы хотите применить этот просмотр потока к дочерней организации?',
  confirmBrowseFlowOverrideToChildren: 'Данная операция удалит все настройки просмотра потока для дочерних организаций.',
  confirmPrintSettingsApplyToChildren: 'Вы хотите применить эти настройки печати к дочерней организации?',
  confirmPrintSettingsOverrideToChildren: 'Данная операция удалит все настройки печати для дочерних организаций.',
  contains: 'Содержит',
  containsHeaderRow: 'Содержит Строку Заголовка',
  content: 'Контент| Контент',
  contentAccessControls: 'Средства Управления Доступом к {content}',
  contentEntity: 'Элемент Контента | Элементы Контента',
  contentNotFound: 'Содержимое не найдено',
  contentUpdatedQueueJob: 'Очередь Обновления Содержимого',
  contentViewerMoreInfo: 'Подробнее',
  contourShape: 'Форма Контура',
  convertEntity: 'Конвертировать {entity}',
  convertToEntity: 'Конвертировать в {entity}',
  copiedPartNumber: 'Артикул детали {partNumber} скопирован',
  copy: 'Скопировать',
  copyAccessControls: 'Скопировать Настройки Управления Доступом',
  copyAccessControlsWarning: 'Это скопирует все установленные настройки управления доступом из выбранной Организации в текущую Организацию',
  copyAndRetain: 'Скопировать и Сохранить для Использования Интеграции',
  copyAndRetainWidget: 'Значение авторизации виджета будет отображаться в приложении только при выполнении функции «Скопировать и сохранить» (Copy & Retain)',
  copyAtoB: 'Скопировать {a} в {b}',
  copyBranches: 'Копирование ветвей',
  copyBranchesMessage: 'Скопируйте выбранные ветви из исходного потока просмотра в целевой.',
  copyContent: 'Копировать {type}? {name}',
  copyItem: 'Скопировать {item}',
  copyItemQuestion: 'Копировать {item}?',
  copyMeMessage: 'Поставить меня в копию к этому сообщению',
  copyPartNumberToClipboard: 'Копировать {label} в буфер обмена',
  copyProduct: 'Копировать продукт',
  copyTo: 'Скопировать в {target}',
  copyingItem: 'Копирование {item}',
  copyrightMessage: '© 2010–{year} Documoto Inc. Все права защищены.',
  count: 'Счет',
  country: 'Страна | Страны',
  coverAmpStitchPages: 'Сшитые и Титульные Страницы',
  coverPages: 'Титульные Страницы',
  createAssembly: 'Создать Сборку',
  createNewProductPage: 'Создать новую страницу продукта',
  created: 'Создано',
  createdBy: 'Создано {name}',
  createdDate: 'Дата создания',
  createdOn: 'Создано',
  currentPassword: 'Текущий Пароль',
  custom: 'Пользовательский',
  czechDescription: 'Описание На Чешском',
  czechName: 'Название На Чешском',
  dashboard: 'Панель инструментов | Панели инструментов',
  dashboardLibrary: 'Библиотека Панели Управления',
  dataInsights: 'Представление Данных',
  dataInsightsInfoMessage: 'Центр Отчетов и Панели Управления для представления данных о содержимом, пользовательской информации и библиотечных данных.',
  dataMapping: 'Сопоставление Данных / Образцы Данных (до 10 строк)',
  dataOptions: 'Параметры данных',
  date: 'Дата',
  dateModified: 'Дата Обновления',
  debugPageBuilderPLZ: 'Отладка PLZ Конструктора страниц',
  december: 'Декабрь',
  decreaseHotpoint: 'Снижение Центральной Точки',
  'default': 'По умолчанию',
  defaultAddress: 'Адрес по умолчанию',
  defaultBrowseFlow: 'Просмотр Потока по умолчанию',
  defaultCurrencyCode: 'Валютный Код по умолчанию',
  defaultCurrencySymbolOn: 'Символ валюты по умолчанию вкл.',
  defaultEmailRecipient: 'Получатель Электронного Письма по умолчанию | Получатели Электронного Письма по умолчанию',
  defaultImage: 'Изображение по умолчанию | Изображения по умолчанию',
  defaultImagesManager: 'Менеджер Изображений по умолчанию',
  defaultItemImage: 'Изображение {item} по умолчанию',
  defaultPartsListLayout: 'Раскладка Списка Деталей по умолчанию',
  defaultPartsListLayoutHelp: 'Раскладка деталей по умолчанию слева или под изображением',
  defaultSearchMode: 'Режим Поиска по умолчанию',
  defaultSearchModeHelp: 'Метод глобального поиска по умолчанию для \'содержит\' или \'точно\'',
  defaultSortMode: 'Режим Сортировки по умолчанию',
  defaultSupplier: 'Поставщик По Умолчанию',
  defaultTocStateOpen: 'Отрытое Содержание по умолчанию',
  defaultTocStateOpenHelp: 'Определяет, должно ли содержание быть автоматически открыто при просмотре книги',
  defaultUom: 'ЕИ По Умолчанию',
  defaultValue: 'Значение По умолчанию',
  defaultView: 'Представление по умолчанию',
  defaults: 'По умолчанию',
  defaultsAndCapabilities: 'Настройки по умолчанию и Дополнительные Возможности',
  'delete': 'Удалить',
  deleteAll: 'Унаследовать От Родителя',
  deleteAnyPartnerApiKeys: 'Удалить все ключи API партнеров, которые были предоставлены SmartEquip.',
  deleteContent: 'Вы уверены, что хотите удалить {item}? {name}',
  deleteFilesMessage: 'Вы действительно хотите удалить {count} файл(а/ов)?',
  deleteHotpointLinksTitle: 'Вы действительно хотите удалить ссылку (-и) hotpoint?',
  deleteMessage: 'Действительно удалить?',
  deletePart: {
    affectedCarts: 'Эта часть будет полностью удалена со всех корзин, в которых она содержится.',
    deletingPartNumber: 'Будет удалено: {partNumber}.',
    infoOne: 'Функция удаления частей начнет действовать немедленно в Библиотеке и контенте администратора. Удаленная часть будет доступна для поиска, пока не произойдет переиндексация в течение нескольких минут.',
    infoTwo: 'Это действие невозможно отменить без помощи специалистов Службы поддержки Documoto. По истечении 90 дней удаленная запись и все ассоциации будут полностью стерты.'
  },
  deletePartCollectionConfirmMsg: 'Вы действительно хотите удалить {partCollection} из {productPage}?',
  deletePartInUse: {
    body: 'На платформе Documoto в данный момент поддерживается лишь функция удаления частей, которые не содержатся на страницах. Чтобы продолжить этот процесс, удалите данную часть со всех опубликованных или черновых страниц.',
    submitLabel: 'Перейти к страницам',
    title: 'Эта часть содержится на странице (страницах) и не может быть удалена.'
  },
  deleteProductPage: {
    deletingIdentifier: 'Будет удалено: {identifier}.',
    infoOne: 'Функция удаления страниц продуктов начнет действовать немедленно в разделах «Библиотека» и «Контент администратора». Удаленная страница продукта будет доступна для поиска, пока не произойдет переиндексация в течение нескольких минут.',
    infoTwo: 'Это действие невозможно отменить без помощи специалистов Службы поддержки Documoto. По истечении 90 дней удаленная запись и все связанные с ней данные будут полностью стерты.'
  },
  deleteRelated: 'Действительно удалить {count} {type}?',
  deleteSelectedCriteria: 'Удалить Выбранные Критерии',
  deleteTagsTitle: 'Вы действительно хотите удалить тег (-и)?',
  deleteTaxonMessage: 'Это действие навсегда удалит этот таксон вместе со всеми его дочерними элементами. Вы уверены, что хотите продолжить?',
  deleteTaxonomyMessage: 'Это действие навсегда удалит все таксоны для этой Организации или Участника. Вы уверены, что хотите продолжить?',
  deleteTenantSupplier: 'Действительно удалить этого поставщика для участника?',
  deletedItem: 'Удалено {item}',
  demo: 'Демонстрация',
  description: 'Описание',
  deselectAll: 'Снять Все Выделение',
  deselectCriteria: 'Отменить Выбор Критериев',
  detail: 'Сведения',
  diagonal: 'Диагональ',
  diameter: 'Диаметр',
  disable: 'Отключить',
  disableAll: 'Отключить все',
  disableDocumotoTenant: 'Отключить участника Documoto',
  disableFwdReindex: 'Отключить пересылку целевых медиафайлов реиндексирования для DSW',
  disableLibraryBannerImage: 'Отключить изображение баннера библиотеки',
  disableSmartEquipModalTitle: 'Действительно отключить эту лицензию?',
  disableTEK: 'Отключить Вход Напрямую Через URL',
  disableUserLogin: 'Отключить вход по имени пользователя / паролю',
  disableUserLoginErrorMessage: 'В вашей организации требуется аутентификация через SSO. Вход по имени пользователя и паролю не разрешен для вашей группы пользователей. Выполните вход с помощью SSO.',
  disableUserLoginTooltip: 'Чтобы включить эту функцию, необходима настроенная конфигурация SSO. Если SSO не настроено, соответствующие пользователи потеряют доступ к Documoto.',
  disabled: 'Отключенный',
  discard: 'Отменить',
  discardChanges: 'Отменить изменения',
  discardQ: 'Отменить изменения?',
  discountPrice: 'Цена Со Скидкой',
  discounted: 'Со скидкой',
  discountedPrice: 'Цена Со Скидкой',
  discountedTotal: 'Сумма С Учетом Скидки',
  displayInOrdersList: 'Отобразить в Списке Заказов',
  displayLocation: 'Место отображения',
  displayOrder: 'Порядок Отображения',
  displayOrderDescription: 'Устанавливает порядок отображения Фильтров в выпадающем окне для тегов типа контента',
  displaySupplierPartInfo: 'Показать поставщика в сведениях о детали',
  document: 'Документ | Документы',
  documentLabel: 'Документ | Документы',
  documentSettings: 'Настройки документа',
  documotoAcademy: 'Академия Documoto',
  documotoLicensePackage: 'Лицензионный пакет Documoto',
  domain: 'Домен',
  domainEmptyMessage: 'Поле с разрешенным доменом не может быть пустым',
  domainInvalidMessage: 'Необходимо указать действительное имя домена',
  download: 'Загрузить',
  downloadBrowser: 'Загрузите один из этих удобных браузеров.',
  downloadFailed: 'Ошибка при загрузке {name}',
  downloadStarted: 'Выполняется загрузка {name}',
  draft: 'Черновик | Черновики',
  draftBomDeleteTitle: 'Вы действительно хотите удалить эту деталь со страницы?',
  draftBomDropError: 'Невозможно разместить детали глубже 5-го уровня',
  draftBomEmptyField: 'Все поля в списке "Детали" должны быть заполнены',
  draftBomError: 'Ошибка при работе с черновиком Спецификации',
  draftBomMultipleDeleteTitle: 'Вы действительно хотите удалить эти детали со страницы?',
  draftBomQuantityError: 'Значение должно быть целым числом',
  draftPage: 'Черновик Страницы',
  draftPageDelete: 'Удалить Черновик',
  draftPageDeleteMessage: 'Черновик страницы успешно удален.',
  draftPageDeleteWarning: 'Удаление черновика Страницы приведет к удалению текущих обновлений.',
  draftPageLastUpdated: 'Черновик. Последнее Обновление: {date} {username}',
  draftPageLoadError: 'Не удалось загрузить страницу проекта.',
  draftPageProcessingPlz: 'Страница загружается из PLZ-файла',
  draftPagePublishInProgress: 'Текущая Страница: "Публикация"',
  draftPageSaveSuccess: 'Черновик страницы успешно сохранен.',
  draftPageSaveUnsuccessful: 'Не удалось сохранить черновик страницы.',
  draftSheetImageHotpointsFailure: 'Не удалось сгенерировать основные точки {algorithm} для чернового изображения.',
  draftValidationMessage: {
    empty: 'Отсутствие Ошибок/Предупреждений Во Время Проверки',
    hotpointOrHotpointLink: 'У элемента спецификации {item} отсутствует центральная (-ые) точка (-и) / ссылка (-и) центральной (-ых) точки (-ек)',
    item: 'ПРЕДУПРЕЖДЕНИЕ: Для BOM с артикульным номером {partNumber} не указан номер товара',
    quantity: 'Для элемента спецификации {item} не указано количество',
    supersede: 'Запчасть {partNumber} замещена запчастью {supersededPartNumber} в связи с заменой.',
    tag: 'У тега {tagName} для элемента спецификации {item} отсутствует значение тега',
    translationDescription: 'Для элемента спецификации {item} отсутствует перевод описания на {lang}',
    uom: 'Для элемента спецификации {item} не указана единица измерения'
  },
  drawAutohotpointRegion: 'Нарисовать {shape} размер',
  drawMinimumArea: 'Нарисовать минимальную область',
  dropFileMessage: 'Перенесите файл сюда или нажмите для загрузки.',
  duplicate: 'Дублировать',
  duplicateSaveError: 'Дублирующая запись. Невозможно сохранить.',
  dutchDescription: 'Описание На Нидерландском',
  dutchName: 'Название На Нидерландском',
  dynamic: 'Динамический',
  dynamicNaming: 'Динамическое Присвоение Имен',
  ecommerce: 'Электронная коммерция',
  ecommerceEmailFormatCreated: 'Формат электронного сообщения онлайн-коммерции создан',
  ecommerceEmailFormatSaved: 'Формат электронного сообщения онлайн-коммерции сохранен',
  ecommerceLogo: 'Логотип электронной коммерции',
  ecommerceUseExtOrder: 'Электронный магазин использует внешний номер заказа',
  edit: 'Редактировать',
  editItem: 'Редактировать {item}',
  email: 'Электронная почта',
  emailAsCsv: 'Отправить электронной почтой в формате CSV (необходимый формат для импорта)',
  emailAsXlsx: 'Отправить электронной почтой в формате XLSX',
  emailBasicPartInfo: 'Отправить электронной почтой информацию про основную деталь',
  emailComments: 'Отправить электронной почтой комментарии',
  emailDetails: 'Отправить электронной почтой подробные сведения',
  emailDisplayedCartColumns: 'Отправить электронной почтой столбцы, которые отображаются в корзине',
  emailFormat: 'Формат электронного сообщения',
  emailFormatTemplate: 'Шаблон формата электронного сообщения | Шаблоны форматов электронных сообщений',
  emailList: 'Список Электронных сообщений',
  emailMessage: 'Необходим адрес электронной почты',
  emailRecipient: 'Получатель электронного письма| Получатели электронного письма',
  emailRecipientMessage: 'Письмо будет отправлено на данную электронную почту, когда статус заказ измениться на',
  emailSubject: 'Отправить электронной почтой тему',
  emptyBomState: 'Номенклатура Спецификации для этой страницы не определена. Нажмите "+",{add}чтобы начать',
  emptyMessage: {
    orderSuggestions: 'Похоже, что пока нет Рекомендаций к Заказу для этой детали.'
  },
  enable: 'Включить',
  enable3d: 'Включить 3D',
  enable3dIllustrations: 'Включить 3D-иллюстрации',
  enable3dThumbnails: 'Включить 3D-эскизы',
  enableAPIKeyAdmin: 'Включить ключ API администратора',
  enableAll: 'Включить все',
  enableCommerce: 'Включить Торговлю',
  enableEcommerceOrderManagement: 'Включить управление заказом',
  enableExportToLinkOne: 'Включить экспорт в LinkOne',
  enableExportToSmartEquip: 'Включить экспорт в SmartEquip',
  enableExporter: 'Включить экспортер',
  enableIframeSupport: 'Включить поддержку iFrame',
  enableKnowledgeBase: 'Включить поиск с поддержкой ИИ',
  enableLibraryBetaFeatures: 'Включить бета‑функции Библиотеки',
  enableMediaCategorySearch: 'Включить группировку по категориям медиафайлов в контекстном поиске',
  enablePDFDownloadWarning: 'Включить предупреждение о загрузке больших PDF-файлов',
  enablePLZToDraft: 'Включить обработку PLZ с созданием черновика',
  enablePerformanceLogging: 'Включить журналирование производительности',
  enableQuickAddToCart: 'Включить быстрое добавление в корзину',
  enableQuickAddToCartHelpContext: 'Если выбран вариант «Включить», над областью просмотра содержимого появится функция быстрого добавления в корзину.',
  enableRocketUi: 'Включить взаимодействие клиента «Rocket User Experience»',
  enableSmartEquipApiIntegration: 'Включить интеграцию API SmartEquip',
  enableWidgetLogo: 'Включить логотип виджета Documoto',
  enableWidgets: 'Включить виджеты',
  enabled: 'Включенный',
  encryptedKey: 'Зашифрованный Ключ',
  endDate: 'Дата завершения',
  endDateBad: 'Дата начала должна совпадать с датой окончания или предшествовать ей.',
  enforceNumericSize: 'Применить Числовой Размер',
  englishDescription: 'Описание На Английском',
  englishName: 'Название На Английском',
  enterReportParameters: 'Введите Параметры Отчета',
  enterUniqueNameForNewItem: 'Введите уникальное имя для нового {item}',
  enterValidEmail: 'Пожалуйста, введите действительный адрес электронной почты',
  enterValidNumber: 'Пожалуйста, введите действительное число',
  enterprise: 'Предприятие',
  entityType: 'Тип элемента | Типы элементов',
  erp: 'ERP',
  erpEndpointConfig: 'Конфигурация конечной точки ERP',
  erpPartInfo: 'Продолжительность кэширования информации компонента ERP, минуты',
  erpSystem: 'Система ERP',
  erpSystemSaved: 'ERP‑система сохранена',
  erpSystems: 'ERP‑системы',
  error: 'Ошибка',
  errorDeletePageMessage: 'При удалении этой страницы возникла проблема.',
  errorInputParsing: 'Проблема с разбором входного файла.',
  errorPageMessage: 'Произошла ошибка.',
  errorPageTitle: 'Произошла ошибка…',
  errorType: {
    error: 'Ошибка',
    warning: 'Внимание'
  },
  essential: 'Основное | Основы',
  eta: 'Расчетное время прибытия',
  etlJob: 'Извлечение, Преобразование И Загрузка',
  exact: 'Точно',
  excelFile: 'Файл Excel',
  existing: 'Существующ.',
  expandAll: 'Развернуть Все',
  'export': 'Экспортировать',
  exportAsCSVDropdown: 'Экспортировать в формате CSV',
  exportAsCsv: 'Экспортировать в формате CSV (Необходимый Формат для Импорта)',
  exportAsHtml: 'Экспорт в формате HTML',
  exportAsPdf: 'Экспортировать в формате PDF',
  exportAsPlz: 'Экспортировать в формате PLZ',
  exportAsXlsx: 'Экспортировать в формате XLSX',
  exportBasicPartInfo: 'Экспортировать Информацию про Основную Деталь',
  exportCartToXlsxDisabled: 'Отключить Экспорт Корзины в формате XLSX',
  exportCartToXlsxEnabled: 'Включить Экспорт Корзины в формате XLSX',
  exportDisplayedCartColumns: 'Экспортировать Колонки, которые Отображаются в Корзине',
  exportJob: 'Операция по экспорту',
  exportLane: 'Дорожка экспорта',
  exportMessage: 'Успешно отправленная операция по экспорту.',
  exportParts: 'Экспортировать Детали',
  exportPartsXlsx: 'Экспорт деталей в XLSX',
  exportSearch: 'Экспортировать Поиск',
  exporter: 'Экспортер',
  exporterMessage: 'Позволяет экспортировать контент',
  external: 'Внешний ресурс | Внешние ресурсы',
  externalUrl: 'Внешний URL',
  faceted: 'Фасетный',
  facetedTag: 'Значения поиска должны быть многофункциональными',
  facetedTagTooMany: 'Тег превышает лимит 1000 уникальных значений тега',
  failedAction: '{content} не удалось {action}.',
  failedProcessContentSql: 'Не удалось обработать Информацию по причине неавторизованного текста. Повторно загрузите поддерживаемую информацию.',
  failedToCopy: 'Не удалось скопировать {content}.',
  failedToDelete: 'Не удалось удалить {content}.',
  failedToLoad: 'Не удалось загрузить {content}.',
  failedToSave: 'Не удалось сохранить {content}.',
  failedToSubmitFeedback: 'Не удалось отправить отзыв.',
  failedToSubmitItem: 'Не удалось отправить {item}',
  failedToUpdate: 'Не удалось обновить {content}.',
  'false': 'Нет',
  faq: 'Вопросы и ответы',
  favorites: 'Избранное',
  favoritesLists: 'Список Избранного',
  february: 'Февраль',
  feedbackForm: 'Оставить Отзыв',
  feedbackFormMessage: 'Расскажите о функциях, которые вы хотели бы увидеть',
  field: 'Поле | Поля',
  fieldDefinition: 'Определение Поля',
  fieldName: 'Название поля',
  file: 'Файл | Файлы',
  fileUpload: 'Отправка файла',
  filename: 'Имя файла',
  filesSubmitted: 'Файлы переданы на обработку',
  fill: 'Заполнить',
  filter: 'Фильтр | Фильтры',
  filterBoundsError: 'Фильтр должен содержать 3 или более символов',
  filterBy: 'Фильтровать по…',
  filterOrgNameOnly: 'Фильтр: Только Имя Организации',
  filterOrgParentNames: 'Фильтр: Названия Организации и Родителя',
  filterable: 'Фильтруемый',
  filterableTag: 'Тег, по которому можно фильтровать',
  finnishDescription: 'Описание На Финском',
  finnishName: 'Название На Финском',
  firstName: 'Имя',
  firstNameEmpty: 'Имя должно быть заполнено',
  fixedHotpointSize: 'Фиксированный Размер Ссылки-якоря',
  font: 'Шрифт| Шрифты',
  footer: 'Нижний колонтитул',
  forSearchTerm: 'для {term}',
  forgotPassword: 'Не могу вспомнить Пароль',
  forgotPasswordMessage: 'Письмо с инструкциями по смене пароля выслано на адрес указанного пользователя.',
  forgotPasswordSuccess: 'Если указанное имя пользователя действительно, на сохраненный адрес будет отправлено письмо с инструкциями по смене пароля.',
  form: 'Форма | Формы',
  formCount: 'Количество Форм',
  formName: 'Имя формы',
  formType: 'Тип формы',
  format: 'Формат',
  formattingOptions: 'Параметры форматирования',
  freezeImage: 'Зафиксировать изображение',
  frenchDescription: 'Описание На Французском',
  frenchName: 'Название На Французском',
  fri: 'Пт',
  from: 'От',
  fromDate: 'Начальная Дата',
  frontCover: 'Обложка',
  frontStitch: 'Передний Шов',
  fullScreen: 'Полноэкранный',
  gdprFaqs: 'Вопросы и ответы по Общим положениям о защите данных',
  gdprMessage: 'Выполняя вход в этот раздел нашего сайта, вы подтверждаете, что вам известно об использовании нами необходимых файлов cookie. Эти файлы cookie необходимы для обеспечения навигации в наших Услугах. Без данных файлов cookie мы не сможем предоставить вам запрошенные услуги. Для получения дополнительной информации ознакомьтесь с нашей {policy}.',
  general: 'Общее',
  generalSearch: 'Общий Поиск',
  generalSearchCriteriaAlreadySet: 'Критерии «Общего поиска» уже выбраны.',
  generic: 'Исходный',
  germanDescription: 'Описание На Немецком',
  germanName: 'Название На Немецком',
  goTo: 'Перейти',
  goToHome: 'Перейти на Главную страницу',
  goToJobManager: 'Перейти к Диспетчеру Операций',
  goToPartCollections: 'Перейти к {partCollections}',
  goToSearch: 'Перейти к Поиску',
  gotIt: 'OK',
  hashKey: 'Хеш-ключ',
  header: 'Заглавие',
  headerAmpFooter: 'Верхнее и Нижнее Меню',
  help: 'Справка',
  helpCenter: 'Центр Поддержки',
  hideBookInSearchAndRecent: 'Не показывать Книги в Результатах Поиска и в Недавно Добавленном',
  hideDuplicatePages: 'Не показывать Страницы-дубликаты',
  hidePageInSearchAndRecent: 'Не показывать Страницы в Результатах Поиска и в Недавно Добавленном',
  hidePartInSearchAndRecent: 'Не показывать Детали в Результатах Поиска и в Недавно Добавленном',
  highlightDescription: 'Выделите детали в списке деталей с помощью этого тега',
  history: 'История',
  home: 'Главный экран',
  homePageSettings: 'Настройки домашней страницы',
  homepageOnly: 'Только главная страница',
  horizontal: 'Горизонтальный',
  host: 'Хост',
  hotpoint: 'Ссылка-якорь | Ссылки-якоря',
  hotpointCalloutBehavior: 'Режим выноски центральной точки',
  hotpointLink: 'Ссылка Hotpoint | Ссылки Hotpoint',
  hotpointLinksWillBeCreated: 'Ссылки-якоря будут созданы в {count} {content}',
  hotpointShift: 'Центральная Точка (Shift + H)',
  hotpointZoomBehavior: 'Режим масштабирования центральной точки',
  hotpointsGenerated: 'Количество найденных на изображении горячих точек составляет {count}.',
  hourlyDWSRequestLimit: 'Ограничение на число запросов DWS в час',
  hourlyRESTRequestLimit: 'Ограничение на число запросов REST в час',
  htmlUiUserSwitchEnabled: 'Переключатель пользователя интерфейса HTML включен',
  hungarianDescription: 'Описание На Венгерском',
  hungarianName: 'Название На Венгерском',
  icon: 'Значок',
  id: 'Идентификатор',
  identifier: 'Идентификатор',
  identifierRequiredErrorMessage: 'Укажите идентификатор',
  ignore: 'ИГНОРИРОВАТЬ',
  ignoreAccessControls: 'Игнорировать Настройки Управления Доступом',
  ignoreMatchingTranslations: 'Игнорировать переводы с соответствующими локалями при импорте',
  illustration: 'Иллюстрация | Иллюстрации',
  image: 'Изображение | Изображения',
  imageDeleteMessage: 'Вы действительно хотите удалить это Изображение Страницы?',
  imageDimensionsExceededMessage: 'Максимальный размер изображения в Documoto составляет 65,5 мегапикселя (8191 × 8191 пиксель).  Изображение, которое вы пытаетесь загрузить, превышает максимальный размер и не может быть загружено. Нажмите "Изменить размер", чтобы разрешить Documoto изменить размер и вставить изображение, или выберите "Отмена", чтобы отредактировать изображение и вставить его вручную.',
  imageOptimizer: 'Оптимизатор Изображений',
  imageSaveFail: 'Не Удалось Сохранить Изображение',
  imageSaveSuccess: 'Успешно Обновленные Изображения',
  imageSizeExceededMessage: 'Максимальный размер файла изображения, допустимый в Documoto, составляет {size} MB. Изображение, которое вы пытаетесь загрузить, превышает максимальный размер и не может быть загружено. Измените размер изображения, чтобы добавить его на эту страницу.',
  imageSizeExceededTitle: 'Превышен Максимальный Размер Изображения',
  imageUploadFailure: 'Не Удалось Загрузить Изображение',
  'import': 'Импортировать',
  importBOM: 'Импортировать Список Спецификаций',
  importBOMError: 'Не удалось обработать образцы данных. Перепроверьте источник входных данных',
  importName: 'Название импорта',
  importParts: 'Импортировать Детали',
  inCart: 'В Корзине',
  inCartDescription: 'Отображать теги в корзине',
  inPartsList: 'В Списке Деталей',
  inPartsListDescription: 'Отображать теги в списке деталей',
  inch: 'Дюйм| Дюймы',
  includeComments: 'Учитывать Комментарии',
  includeCommentsAuthorAndDate: 'Учитывать Комментарий Автора и Дату',
  includeHeaderRow: 'Включить строку заголовка',
  includeImages: 'Учитывать Изображения',
  includeNewParts: 'Включать только «новые» запчасти (которых нет в Documoto)',
  includePagePartDetails: 'Включить сведения страницы на уровне запчасти',
  includePagesIndex: 'Учитывать Индекс Страниц',
  includePartDetails: 'Включить сведения на уровне запчасти',
  includePartsIndex: 'Учитывать Индекс Деталей',
  includePartsList: 'Учитывать Список Деталей',
  includeSubChapters: 'Включить Подразделы',
  includeWatermark: 'Включить водяной знак?',
  increaseHotpoint: 'Увеличение Центральной Точки',
  indefinitely: 'Бессрочно',
  indexIncludeTimestamp: 'Индекс включает метку времени',
  indexLane: 'Дорожка индекса',
  indexQueueJob: 'Очередь индексирования',
  indexed: 'Проиндексировано',
  indexingConfiguration: 'Конфигурация индексирования',
  info: 'Информация',
  information: 'Информация',
  inherit: 'Наследовать',
  inherited: 'Унаследовано',
  inheritedParent: 'Унаследовано от Родителя.',
  inputSource: 'Источник Входных Данных',
  inputSpecification: 'Параметры Входных Данных',
  inputType: 'Тип Входных Данных',
  inputTypeListboxWarning: 'Конфигурации сортировки будут отображены после сохранения',
  insertDataField: 'Вставить поле данных',
  integration: 'Интеграция | Интеграции',
  integrationsAddPartToErpCart: '{action} Добавить Деталь в Корзину ERP',
  integrationsAddToShoppingCartPricingFromErp: '{action} Добавить к Определению Стоимости Корзины из ERP',
  integrationsDisableErp: 'Отключить ERP',
  integrationsDoErpForQuotes: 'Провести ERP для Расценки',
  integrationsEnableErp: 'Включить ERP',
  integrationsEnableFetchPartInfoFromErp: 'Включить Запрос Информации о Детали из ERP',
  integrationsEnableScopeErp: 'Включить {scope} ERP',
  integrationsEnableSendShoppingCartToErp: 'Включить Отправку Корзины в ERP',
  integrationsEnableSyncPoAddressWithErp: 'Включить Синхронизацию Почтового Адреса с ERP',
  integrationsErpAvailabilityMappedFrom: 'Доступность ERP, спланированная из',
  integrationsErpCurrencyCodeMappedFrom: 'Код Валюты ERP, Спланированный Из',
  integrationsErpDiscountedPriceMappedFrom: 'Скидочная Цена ERP, Спланированная Из',
  integrationsErpEtaMappedFrom: 'Время поставки ERP, Спланированное Из',
  integrationsErpMappings: 'Планирование ERP',
  integrationsErpRetailPriceMappedFrom: 'Розничная Цена ERP, Спланированная Из',
  integrationsErpWholesalePriceMappedFrom: 'Оптовая Цена ERP, Спланированная Из',
  integrationsInvokeGetPartInfoFromClient: 'Запросить Номер Детали от Клиента',
  integrationsParseAddressForType: 'Приравнять Адрес к Типу',
  integrationsShoppingCartAndPartsTitle: 'Корзина и Детали',
  integrationsShoppingCartAvailability: '{action} Доступность Корзины',
  integrationsShoppingCartEtaFromErp: '{action} Предполагаемое Время Прибытия для Корзины из ERP',
  internalApiKey: 'Внутренний ключ API',
  internalDescription: 'Внутреннее Описание',
  internalName: 'Внутреннее Имя',
  internalNameOptional: 'Ваш идентификатор для тега',
  internalNameRequired: 'Необходимо указать имя',
  invalidDecimals: 'Разрешено не более двух символов после десятичного разделителя',
  invalidField: '{field} недействительно',
  invalidFileType: 'Тип файла не поддерживается. Полный список поддерживаемых файловых расширений приводится в Центре Поддержки Клиентов Documoto.',
  isSearchable: 'С Возможностью Поиска',
  isSystem: 'Система',
  italianDescription: 'Описание На Итальянском',
  italianName: 'Название На Итальянском',
  item: '#',
  itemAlt: 'Пункт',
  itemCopied: '{item} скопировано',
  itemDeleted: '{item} удалено',
  itemDetails: 'Подробные сведения об элементе',
  itemInProgress: '{item} в процессе',
  itemInformation: '{item} информация',
  itemMustBeLteItem: '{itemA} должен быть равен или находиться перед {itemB}.',
  itemMustBeUnique: '{item} должен быть уникальным',
  itemMustBeUniqueAndNotEmpty: '{item} должен быть уникальным и является обязательным',
  itemName: 'Имя {item}',
  itemSaved: '{item} сохранено',
  itemSpecification: 'Параметры Элемента',
  january: 'Январь',
  japaneseDescription: 'Описание На Японском',
  japaneseName: 'Название На Японском',
  job: 'Операция | Операции',
  jobManager: 'Диспетчер Операций',
  jobManagerMessage: 'Экспортируйте, публикуйте и распечатывайте или загружайте операции',
  july: 'Июль',
  june: 'Июнь',
  knowledgeBase: {
    config: {
      fetchUsage: 'Получить данные об использовании',
      maxTokensDefault: 'Максимальное количество токенов в месяц по умолчанию',
      maxTokensOverride: 'Переопределенное максимальное количество токенов в месяц',
      noData: 'Данные о конфигурации отсутствуют.'
    },
    errors: {
      maxFileSizeExceeded: 'Размер файла превышает допустимый в Базе знаний.',
      maxTokensExceeded: 'Вы достигли лимита токенов.',
      pageNavigationFailed: 'Не удалось перейти на страницу.'
    },
    feedback: {
      prompt: 'Спасибо за отзыв. Что было не так с этим ответом?',
      reasons: {
        hardToUnderstand: 'Трудно понять',
        incorrect: 'Неправильный',
        missingInfo: 'Отсутствует информация',
        offTopic: 'Не по теме'
      },
      submitted: 'Ваш отзыв отправлен.'
    },
    library: {
      buttonText: 'Спросить ИИ',
      disclaimer: 'Функция Documoto AI может допускать ошибки. Проверяйте правильность ответов.',
      inputPlaceholder: 'Задайте вопрос…',
      noContent: 'Для этого документа контекст отсутствует.',
      promptDefault: 'Ответы формируются только на основе этого документа. Задавайте по одному вопросу за раз.',
      reference: 'Ссылка на PDF',
      serviceError: 'Ошибка генерации контекста.',
      title: 'Поиск с поддержкой ИИ'
    },
    tenantKnowledgeBase: 'Участник Базы знаний',
    usage: {
      inputTokens: 'Общее количество входящих токенов',
      noData: 'Данные по использованию отсутствуют.',
      outputTokens: 'Общее количество исходящих токенов',
      title: 'Сводка по использованию токенов',
      totalTokens: 'Общее количество использованных токенов'
    }
  },
  koreanDescription: 'Описание На Корейском',
  koreanName: 'Название На Корейском',
  label: 'Ярлык | Ярлыки',
  labelKey: 'Ключ к ярлыку',
  landscape: 'Альбом',
  laneConfiguration: 'Конфигурация дорожек',
  language: 'Язык',
  largePDFDownloadWarning: 'Из-за большого размера загружаемого PDF-файла может потребоваться больше времени для отображения документа в приложении. Дождитесь, пока загрузится файл.',
  lastGenerated: 'Последнее Созданное',
  lastModifiedDate: 'Дата последнего изменения',
  lastName: 'Фамилия',
  lastNameEmpty: 'Поле фамилии должно быть заполнено',
  lastUpdatedOn: 'Последнее обновление:',
  layout: 'Макет',
  layoutOptions: 'Параметры Макета',
  ledger: 'Формат Ledger',
  left: 'Слева',
  legal: 'Формат Legal',
  letter: 'Формат Letter',
  library: 'Библиотека',
  libraryAdmin: 'Администратор Библиотеки',
  libraryBannerLogo: 'Логотип баннера библиотеки',
  librarySettings: 'Настройки Библиотеки',
  librarySettingsDescription: 'Эти настройки контролируют разные элементы и опции Библиотеки. С осторожностью применяйте изменения. Обратитесь в Службу Поддержки Documoto для получения подробной информации.',
  licenseConfiguration: 'Конфигурация лицензий',
  line: 'Строка',
  lineTool: 'Инструмент “Прямая”',
  link: 'Ссылка | Ссылки',
  listBox: 'Окно Списка',
  listBoxValue: 'Отобразить список Значения Поля | Отобразить список Значений Поля',
  listValue: 'Отобразить список Значения | Отобразить список Значений',
  load: 'Загрузить',
  loadMore: 'Загрузить еще',
  loading: 'Загрузка',
  loadingParts: 'Загрузка деталей',
  locale: 'Место',
  logiReportName: 'Название Отчета Logi',
  logiReportToggle: 'Отчет Logi?',
  login: 'Вход в систему',
  loginBackground: 'Фоновое изображение для входа в систему',
  loginGDPRMessageBeginning: 'На этом сайте используются файлы cookie. Продолжая пользоваться этим сайтом, вы разрешаете использование файлов cookie. Для получения дополнительной информации ознакомьтесь с ',
  loginGDPRMessageEnd: 'и наш',
  loginSSO: 'Вход SSO',
  logo: 'Логотип | Логотипы',
  logout: 'Выход из системы',
  lookupLoadParts: 'Поиск/Загрузка Деталей из Documoto при импорте',
  lowerBound: 'Нижняя Граница',
  mOfNShown: 'Показано {m} из {n}',
  mToM: 'M2M',
  mainInfo: 'Основная Информация',
  mainLogo: 'Основной Логотип',
  makePagesDivisibleBy: 'Сделать Страницы Кратными:',
  manageItem: 'Редактировать {item}',
  management: 'Управление',
  manuallyResetPassword: 'Сбросить пароль вручную',
  manuallySetPassword: 'Задать пароль вручную',
  march: 'Март',
  margin: 'Расстояние | Расстояния',
  markdown: 'Размер уценки',
  maxCharHelpMessage: 'Укажите максимальную длину (от {min} до {max} симв.).',
  maxCharacters: 'Макс. количество символов',
  may: 'Май',
  media: 'Медиа | Медиа',
  mediaBookDeleteMessage: 'Удаление этих медиа удалит доступ к этому контенту в Библиотеке и Панели Администратора Контента и он станет недоступным для пользователей или Администраторов Контента. Какие-либо детали или страницы, найденные в других книгах, также не будут доступны в Библиотеке.',
  mediaCategory: 'Категория Медиа | Категории Медиа ',
  mediaCategoryEditor: 'Редактор Категорий Медиа',
  mediaCategoryName: 'Название Категории Медиа',
  mediaCategoryNameMissing: 'Все категории медиа должны быть названы',
  mediaDeleteMessage: 'Удаление этого шаблона удалит его из Панели Администратора Контента и он станет недоступным для копирования в новые Медиа.',
  mediaDeleteSuccessText: 'Он будет удален из списков после завершения индексации.',
  mediaDescription: 'Описание медиаресурса',
  mediaIdentifier: 'Идентификатор медиаресурса',
  mediaIdentifierDescription: 'Внутренний номер медиафайла для поиска конечными пользователями',
  mediaName: 'Имя медиаресурса',
  mediaPrintSettingsSaveSuccess: 'Настройки Печати Медиа сохранены',
  mediaWhereUsed: 'Где Используется Медиа',
  menu: 'Меню',
  merge: 'Объединить',
  mergeOrOverrideMessage: 'Перезаписать или объединить эти наименования?',
  mergeWarning: 'Импорт данных приведет к обновлению существующих деталей и добавлению новых записей',
  message: 'Сообщение',
  messageLevel: 'Уровень Сообщения',
  messageMessage: 'Требуется сообщение',
  metadata: 'Метаданные',
  microsite: 'Микросайт | Микросайты',
  micrositeAdmin: {
    cardSubtitle: 'Сжатый файл содержимого и информация о записи HTML',
    cardTitle: 'Содержимое сайта',
    errorRequiredFile: 'Требуется ZIP-файл содержимого сайта',
    fieldFile: 'ZIP-файл содержимого сайта',
    fieldPoint: 'Точка входа HTML'
  },
  minArea: 'Минимальная Область',
  minAreaMessage: 'Требуется минимальное значение. Значение не может выходить за пределы диапазона от 1 до 1500.  Должно быть целочисленным значением.',
  minCharacters: 'Мин. количество символов',
  minMaxCharHelpMessage: 'Укажите мин. и макс. длину (от {min} до {max} симв.). Макс. значение должно быть больше или равно минимальному.',
  mine: 'Мое',
  miscellaneous: 'Разное',
  mon: 'Пн',
  month: 'Месяц',
  moreInfo: 'Подробнее',
  multipleAlternatingPages: 'Множественное Чередование Страниц',
  multipleAlternatingPagesMessage: 'Диаграмма на страницах 1 и 3, список деталей на страницах 2 и 4.',
  multiplePages: 'Множественные Страницы',
  multiplePagesMessage: 'Диаграмма на одной странице, за которой следуют страницы со списком деталей',
  myCart: 'Моя Корзина | Мои Корзины',
  nItemsCreated: '{n} {items} создано',
  nItemsDeleted: '{n} {items} удалено',
  nOfMItems: '{n} из {m} {items}',
  name: 'Имя',
  nameDescriptionHelpText: 'Имя и опциональное описание',
  navigation: 'Навигация',
  'new': 'Новый',
  newAPIKey: 'Новый Ключ API',
  newERPSystem: 'Новая ERP‑система',
  newItem: 'Новый {item}',
  newKeyGenerated: 'Создан Новый Ключ Интеграции; Скопировать и Сохранить для дальнейшего использования',
  newMediaCategory: 'Новая Категория Медиа',
  newPassword: 'Новый Пароль',
  newTenant: 'Новый участник',
  newWidgetKey: 'Новый ключ виджета',
  newWidgetKeyGenerated: 'Новый ключ виджета создан, функция «Скопировать и сохранить» (Copy & Retain) доступна для будущего использования',
  newsItem: 'Новость | Новости',
  noAPIKeys: 'Ключи API не определены.',
  noData: 'Данные Отсутствуют',
  noFileSelected: 'Файл не выбран',
  noFilesSelected: 'Не Выбрано ни одного Файла',
  noFormsMessage: 'Формы Не определены.',
  noIllustrationFound: 'Иллюстраций Не Обнаружено',
  noImageFound: 'Изображений Не Обнаружено',
  noItemAddedToTarget: '{item} не добавлено к {target}. ',
  noItemAvailable: '{item} недоступно',
  noItemFound: '{item} — не найдено.',
  noItemSelected: '{item} не выбрано',
  noItemsFound: 'Объектов Не Найдено',
  noMediaDefined: 'Медиафайлы не определены',
  noMoreResults: 'Результатов больше нет',
  noPartCollectionsFound: '{partCollection} не найдено.',
  noPartsSelected: 'Детали не выбраны.',
  noPrice: 'Запрос Цены',
  noResults: 'Нет результатов',
  noSearchResultsHelpText: 'Ничего не найдено',
  noSearchableCategories: 'Нет доступных категорий для поиска',
  noSearchableTags: 'Нет тегов с возможностью поиска',
  noSuggestions: 'Нет рекомендаций по поисковому запросу',
  noSupercedingPartsFoundForPartNumber: 'Для этого артикула заменяющие детали не найдены.',
  noTagsFound: 'Теги не найдены',
  noTenantSuppliers: 'Участнику не назначены поставщики.',
  noUnsavedChanges: 'Нет Несохраненных Изменений',
  noWidgetKeys: 'Ключи виджетов не определены.',
  node: 'Узел',
  nonSearchableFieldsSuccessfullyUpdated: 'Поля, недоступные для поиска, успешно обновлены.',
  none: 'Нет',
  norwegianDescription: 'Описание На Норвежском',
  norwegianName: 'Название На Норвежском',
  notAvailable: 'Н/П',
  notImplemented: 'Не Реализовано',
  notMapped: 'Не Преобразовано',
  notOrderable: 'Нельзя Заказать',
  notSelected: 'Не выбрано',
  notification: 'Уведомление | Уведомления',
  notificationsMessage: 'Важные объявления и новости',
  november: 'Ноябрь',
  numberOf: '№ {item}',
  numeric: 'Числовой',
  october: 'Октябрь',
  of: 'из',
  off: 'Выкл.',
  offlineContent: 'Контент в Режиме Оффлайн',
  ok: 'OK',
  oldPassword: 'Старый пароль',
  on: 'Вкл.',
  opacity: 'Непрозрачность',
  open: 'Открыть',
  openItem: 'Открыть {item}',
  openTab: 'Открыть ссылку в новой вкладке',
  optimizeIndexJob: 'Оптимизация Индекса',
  optionalConfiguration: 'Дополнительная конфигурация | Дополнительные конфигурации',
  options: 'Опции',
  order: 'Заказ | Заказы',
  orderAttachmentHelpText: 'Вы можете прикрепить до 10 файлов размером до 50 МБ каждый. Допустимые типы файлов: pdf, doc, docx, xls, xlsx, txt, rtf, ppt, pptx, xml, zip, jpg, jpeg, gif, png, bmp, tiff, tif, mp4, mpg, mpeg, avi, mov, rm, wmv, flv, f4v, svg.',
  orderDisable: 'Отключить Историю Заказов',
  orderEmailRecipient: 'Получатель Электронного Сообщения о Заказе | Получатели Электронного Сообщения о Заказе',
  orderEntity: 'Элемент Заказа | Элементы Заказа',
  orderField: {
    nameMessage: 'В случае изменения названия поля заказа / ценового предложения обязательно обновите все использующие это поле формы заказов / ценовых предложений или форматы электронных сообщений.'
  },
  orderFieldCopyMessage: 'Введите уникальное имя для нового поля заказа / ценового предложения',
  orderFieldUneditableRequired: 'В случае присвоения полю заказа / ценового предложения значения «Обязательное», а не «Редактируемое пользователем» завершение обработки формы заказа / ценового предложения может быть невозможным. Убедитесь, что ваши формы заказа / ценового предложения могут быть заполнены.',
  orderFieldsEmptyMessage: 'Поля заказа / ценового предложения не определены.',
  orderFieldsEmptyPrompt: 'Добавить поле заказа / ценового предложения',
  orderForm: {
    uniqueNameInputHint: 'Введите уникальное имя для новой Формы'
  },
  orderFormField: 'Поле заказа / ценового предложения | Поля заказа / ценового предложения',
  orderFormLayout: 'Макет формы заказа / ценового предложения | Макеты формы заказа / ценового предложения',
  orderFormSetDefault: 'Настройка Формы Заказа/Предложения По Умолчанию',
  orderFormType: 'Форма заказа',
  orderLayout: 'Макет Заказа | Макеты Заказа',
  orderManagementApprover: 'Авторизатор Управления Заказом',
  orderManagementDisable: 'Отключить Администратора Управления Заказом',
  orderManagementViewer: 'Окно Просмотра Управления Заказом',
  orderNumber: 'Номер Заказа',
  orderQuoteDeleteWarning: 'Невозможно удалить поля, которые используются в формах заказа или коммерческого предложения, включены в шаблоны электронных писем либо ранее использовались в отправленных заказах или предложениях.',
  orderQuoteEmail: 'Электронное сообщение о заказе/коммерческом предложении | Электронные сообщения о заказах/коммерческих предложениях',
  orderQuoteEmailFormat: 'Формат электронного сообщения о заказе/коммерческом предложении | Форматы электронных сообщений о заказах/коммерческих предложениях',
  orderQuoteEmailFormatCopyMessage: 'Выберите язык для нового формата электронного сообщения о заказе/коммерческом предложении.',
  orderQuoteFetchError: 'Ошибка получения данных формы заказа/коммерческого предложения',
  orderQuoteForm: 'Форма заказа/ценового предложения | Формы заказов/ценовых предложений',
  orderQuoteFormSaved: 'Форма заказа / ценового предложения сохранена',
  orderQuoteSaveConfirmation: 'Сохранить изменения в формах заказов/коммерческих предложений организации?',
  orderQuoteSaveError: 'Ошибка сохранения данных формы заказа/коммерческого предложения',
  orderStatus: 'Статус заказа / ценового предложения | Статусы заказа / ценового предложения',
  orderStatusDeleteMessage: 'Этот статус использовался для заказов, и его нельзя удалить.',
  orderSubmittedMessage: 'Успешно Отправлено',
  orderSuggestion: 'Рекомендация к Заказу | Рекомендации к Заказам',
  orderSuggestionEnable: 'Включить Рекомендации к Заказу',
  orderSuggestionRemovalWarning: 'Эта деталь больше не будет отображаться как рекомендация к заказу. | Эти детали больше не будут отображаться как рекомендация к заказу.',
  orderSuggestionThreshold: 'Максимальное количество Рекомендаций к Заказу',
  orderable: 'С возможностью заказа',
  orderableDescription: 'Деталь можно добавить в корзину и купить',
  orderableLocal: 'Можно заказать на этой странице',
  orderableLocalBlocked: 'Деталь нельзя Заказать с Международной Доставкой',
  ordersLogo: 'Логотип Заказов',
  ordersMessage: 'История оформления заказов',
  org: 'Организация',
  orgAccessControlsWarning: 'Примечание: Родительские организации (например, «родители» или «предки») автоматически получают доступ к контенту, назначенному их дочерним организациям (например, «детям» или «внукам»).',
  orgEmailRecipients: 'Получатели Электронного Письма Организации',
  orgNameOnly: 'Только Имя Организации',
  organization: 'Организация | Организации',
  organizationAdmin: 'Администратор Организации',
  organizationAdminBrowseFlow: 'Организация может использовать просмотр потока по умолчанию, или вы можете поменять его на другой просмотр потока.',
  organizationAdminMessage: 'Осуществляет управление пользователями и настройками организации',
  organizationEmailRecipients: 'Получатели Электронного Письма Организации',
  organizationEmpty: 'Нужно выбрать организацию',
  organizationEnforceAccessControlsForQuickAdd: 'Принудительный Контроль Доступа для Быстрого Добавления',
  organizationKey: 'Ключ Организации',
  organizationLibrarySettingsDescription: 'Эти настройки контролируют разные элементы и опции Библиотеки на уровне Организации. С осторожностью применяйте изменения. Обратитесь в Службу Поддержки Documoto для получения подробной информации.',
  organizationMoveToRoot: 'Перенесите сюда, чтобы перенести в корень',
  organizationName: 'Название организации',
  organizationRearrange: 'Изменить порядок Организаций',
  organizationRearrangeDescription: 'Организационная структура «родитель-ребенок» определяет многие наследуемые атрибуты Организации, такие как Настройки Печати, Стили и многое другое. Перетягивайте Организации для отображения нужной иерархии.',
  organizationReportSettingsSuccessMessage: 'Настройки отчетов сохранены',
  organizationSelect: 'Выбрать Организацию',
  organizationTags: 'Теги Организации',
  organizationsEmpty: 'Похоже, вы еще не создали ни одной организации',
  orientation: 'Ориентация',
  other: 'Другое',
  otherSettings: 'Другие Настройки',
  outboundCustomerIdParameter: 'Исходное Имя Параметра ID Клиента ',
  outboundSessionIdParameter: 'Исходное Имя Параметра ID Сессии',
  outlineMode: 'Режим Контуров (Shift + O)',
  output: 'Вывод',
  outputCatalog: 'Каталог Вывода',
  outputDefinition: 'Определение Вывода | Определения Вывода',
  outputDefinitionDeleted: 'Определение Вывода удалено',
  outputDefinitionSaved: 'Определение Вывода Сохранено',
  outputDestination: 'Настройка вывода',
  outputFileName: 'Имя Файла Вывода',
  outputName: 'Имя Вывода',
  outputSpecification: 'Спецификация вывода',
  outputSubType: 'Подтип Вывода',
  outputType: 'Тип Вывода',
  overridden: 'Перезаписано',
  overriddenByOrg: 'Перезаписано Организацией',
  override: 'Перезаписать',
  overrideBrowseFlow: 'Перезаписать Просмотр Потока',
  overrideFacetLimitValue: 'Переопределение предельного значения грани',
  overrideFontSettings: 'Перезаписать Настройки Шрифта',
  overrideHotpointScale: 'Перезаписать Масштабирование Ссылки-якоря',
  overrideOrderForm: 'Переопределить форму заказа',
  overridePdfNamingStandard: 'Переопределить стандарт именования файлов в формате PDF',
  overridePrintSettings: 'Перезаписать Настройки Печати',
  overrideQuoteForm: 'Переопределить форму коммерческого предложения',
  overrideSvgOpacity: 'Перезаписать Затененность SVG',
  overrideWarning: 'Импорт данных заменит ваш текущий список спецификаций',
  owner: 'Собственник | Собственники',
  page: 'Страница | Страницы',
  pageBomPartsDeleted: 'Такое количество частей на BOM‑странице больше не будет доступно через {filename}: {count}.',
  pageBuilder: 'Конструктор Страниц',
  pageBulkErrorTooManyBooks: 'Ограничить выбранное количество книг не более чем на 1000 наименований',
  pageBulkInsertBooksConfirmInsertAfter: 'Эта операция приведет к вставке {replacement} после {original} в {whereUsedBookCount} {bookUnits}.',
  pageBulkInsertBooksConfirmInsertBefore: 'Эта операция приведет к вставке {replacement} перед {original} в {whereUsedBookCount} {bookUnits}.',
  pageBulkInsertBooksConfirmInsertReplace: 'Эта операция приведет к вставке {replacement} и удалению {original} в {whereUsedBookCount} {bookUnits}.',
  pageBulkInsertConfirmInsertAfter: 'Эта операция приведет к вставке {replacement} после {original} в {whereUsedBookCount} {bookUnits} и {whereUsedTemplateCount} {templateUnits}.',
  pageBulkInsertConfirmInsertBefore: 'Эта операция приведет к вставке {replacement} перед {original} в {whereUsedBookCount} {bookUnits} и {whereUsedTemplateCount} {templateUnits}.',
  pageBulkInsertConfirmInsertReplace: 'Эта операция приведет к вставке {replacement} и удалению {original} в {whereUsedBookCount} {bookUnits} и {whereUsedTemplateCount} {templateUnits}.',
  pageBulkInsertConfirmTitle: 'Вы хотите завершить массовую вставку?',
  pageBulkInsertDiscard: 'Массовая вставка не будет обработана.',
  pageBulkInsertHelpText: 'Эта функция позволяет вставить эту исходную страницу {thisDisplayName} в выбранные части книги, где другая страница {originalDisplayName} уже существует. Как вариант, вы можете также удалить {originalDisplayName} из этих книг.',
  pageBulkInsertInsertAfter: 'Вставить {replacement} ПОСЛЕ {original}',
  pageBulkInsertInsertBefore: 'Вставить {replacement} ПЕРЕД {original}',
  pageBulkInsertInsertReplace: 'Вставить {replacement} и УДАЛИТЬ {original}',
  pageBulkInsertScopeAll: 'Все объекты {type} с целевой страницей {originalDisplayName} ({whereUsedCount} {units})',
  pageBulkInsertScopeNone: 'Ни один объект {type} с целевой страницей {originalDisplayName}',
  pageBulkInsertScopeSome: 'Некоторые объекты {type} с целевой страницей {originalDisplayName}',
  pageBulkInsertStep1: 'Шаг 1: Найдите необходимую целевую страницу',
  pageBulkInsertStep2: 'Шаг 2: Определите, как вставить или заменить страницы',
  pageBulkInsertStep3: 'Шаг 3: Выберите книги, в которые нужно провести массовую вставку.',
  pageBulkInsertStep4: 'Шаг 4. Выберите шаблоны, в которые нужно провести массовую вставку.',
  pageBulkInsertSuccessBody: 'Изменения в оглавлении книги будут применены немедленно. Результаты поиска будут отображены после завершения индексации.',
  pageBulkInsertSuccessTitle: 'Внесена операция по массовой вставке',
  pageBulkInsertTemplatesConfirmInsertAfter: 'Эта операция приведет к вставке {replacement} после {original} в {whereUsedTemplateCount} {templateUnits}.',
  pageBulkInsertTemplatesConfirmInsertBefore: 'Эта операция приведет к вставке {replacement} перед {original} в {whereUsedTemplateCount} {templateUnits}.',
  pageBulkInsertTemplatesConfirmInsertReplace: 'Эта операция приведет к вставке {replacement} и удалению {original} в {whereUsedTemplateCount} {templateUnits}.',
  pageComposer: 'Page Composer',
  pageCreated: 'Страница Создана',
  pageDeleteMessage: 'Функция удаления страниц начнет действовать немедленно в Библиотеке и контенте администратора. Удаленная страница будет доступна для поиска, пока не произойдет переиндексация в течение нескольких минут.',
  pageDeleteMessage2: 'Это действие невозможно отменить без помощи специалистов Службы поддержки Documoto. По истечении 90 дней удаленная запись и все ассоциации будут полностью стерты.',
  pageDescription: 'Описание страницы',
  pageDraftsDeleted: 'Черновые страницы, связанные с этой страницей, будут полностью удалены.',
  pageFile: 'Файл Страницы',
  pageFileRequired: 'Необходим файл страницы.',
  pageFilename: 'Имя файла страницы',
  pageFilenameDeleted: 'Будет удалено: {filename}.',
  pageFit: 'Подогнать по Странице',
  pageHeader: 'Заглавие Страницы',
  pageLabel: 'Страница | Страницы',
  pageLayout: 'Макет Страницы',
  pageName: 'Название страницы',
  pagePart: 'Часть Страницы | Части Страницы',
  pagePartData: 'Данные о Деталях Страницы',
  pagePartLevelDetails: 'Страница запчасти, доступной для заказа/видимой, метки страницы запчасти',
  pagePartNumberVisible: 'Видимый Номер Детали Страницы',
  pagePartOrderable: 'Упорядочиваемая Деталь Страницы',
  pagePartOrderableDescription: 'Упорядочиваемая Деталь с этой страницы',
  pagePartTag: 'Тег Детали Страницы | Теги Детали Страницы',
  pagePartVisibleDescription: 'Номер Детали, видимый на этой странице',
  pageToPartCollectionFailure: 'Не удалось добавить страницу {name} как коллекцию деталей.',
  pageUpdated: 'Страница Обновлена',
  pageUsageDataCouldNotBeLoaded: 'Данные об использовании страницы не удалось загрузить',
  pageViewer: 'Средство Просмотра Страниц',
  pageWidth: 'Ширина Страницы',
  pagesWhereUsed: 'Страница, на Которых Используется',
  parentName: 'Имя Родителя | Имена Родителей',
  part: 'Деталь | Детали',
  partCode: 'Код Детали | Коды Деталей',
  partCodeAddError: 'Нельзя добавить Код(ы) Детали',
  partCodeErrorEmpty: 'Не удалось сохранить: код Детали не может быть пуст',
  partCodeErrorInUse: 'Этот код детали используется деталями в Documoto и не может быть удален. Обратитесь в Службу Поддержки Documoto по адресу support{\'@\'}documoto.com.',
  partCodeErrorNotFound: 'Эти коды не удалены, потому что их не удалось найти. Пожалуйста, убедитесь, что все изменения были сохранены.',
  partCodesManager: 'Менеджер Кодов Деталей',
  partCodesMessage: 'Коды деталей могут использоваться вместо номеров деталей и часто используются для указания того, когда элементы спецификации устарели, недоступны или являются справочными элементами (например, «PNNA», «-», «REF»).',
  partCollection: 'Коллекция деталей | Коллекции деталей',
  partCollectionsDescription: 'Добавьте до 20 {parts} {pages}, чтобы они отображались как {collections} на {productPage}.',
  partCollectionsDescription2: 'Выбранные {collections} определяют, какие {parts} будут доступны конечным пользователям для быстрого доступа или заказа.',
  partCollectionsDescription3: 'Указанный ниже порядок определяет, как они будут отображаться в окне просмотра {productPage} библиотеки.',
  partCollectionsLimitError: 'Разрешено не более {limit} {item1} на {item2}.',
  partCreated: 'Деталь Создана',
  partData: 'Данные о Деталях',
  partDebouncerEmailQueueJob: 'Очередь Электронной Почты',
  partDescription: 'Описание части',
  partEquipmentVerificationBanner: 'Баннер проверки оборудования детали',
  partLabel: 'Деталь | Детали',
  partLevelDetails: 'Цены запчастей, доступных для заказа/видимых, дополнительные пересчеты, метки запчастей',
  partName: 'Название Детали',
  partNumber: 'Номер Детали',
  partNumberCopied: '{label}: скопировано в буфер обмена',
  partNumberDescription: 'Внутренний номер детали для поиска конечными пользователями',
  partNumberSupercededBy: '{partNumber} уже существует как тег SupersededPartNumber для…',
  partNumberVisible: 'Видимый Номер Детали',
  partNumberVisibleDescription: 'Номер детали доступен для конечных пользователей',
  partNumberVisibleLocal: 'Отображается на этой странице',
  partNumberVisibleLocalBlocked: 'Номер Детали не Отображается Глобально',
  partOrderable: 'Упорядочиваемая Деталь',
  partRequired: 'Нужно указать хотя бы одну деталь',
  partTag: 'Тег Детали | Теги Детали',
  partTagProperty: 'Свойство Тега Детали | Свойства Тега Детали',
  partUpdated: 'Запчасть обновлена',
  partVerificationInstructions: 'Убедитесь, что эта деталь подходит для вашего оборудования',
  partialSupport: 'Частичная Поддержка',
  partnerApiKey: 'Ключ API партнера',
  partnerRESTRequestLimit: 'Ограничение на число запросов REST партнера',
  partsBook: 'Книга деталей | Книги деталей',
  partsBulkImport: {
    description: 'Загрузите файл данных для обработки массового импорта деталей. Поддерживаемый формат файлов: XLSX.',
    downloadTemplate: 'Загрузить шаблон XLSX',
    downloadUnprocessedRows: 'Загрузить таблицу необработанных строк',
    hideRequirements: 'Скрыть требования к XLSX',
    overwriteTagValues: 'Перезаписать значения для совпадающих тегов',
    overwriteTranslations: 'Перезаписать совпадающие переводы',
    requirements: {
      discountPrice: {
        description: 'Устанавливает цену со скидкой на уровне участника.'
      },
      enUSDescription: {
        description: 'Перевод описания детали для конкретного языка. См. наше <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">руководство по языковой поддержке</a>.'
      },
      enUSName: {
        description: 'Перевод названия детали для конкретного языка. Для новых деталей необходимо указать как минимум один перевод. См. наше <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">руководство по языковой поддержке</a>.'
      },
      orderable: {
        description: 'Определяет, доступна ли деталь для заказа. Допустимые значения: `true` или `false`. По умолчанию используется `true`.'
      },
      orgDiscountPrice: {
        description: 'Устанавливает цену со скидкой на уровне организации для выбранной организации. Пример заголовка: `<OrganizationName> / Discount Price`'
      },
      orgRetailPrice: {
        description: 'Устанавливает розничную цену на уровне организации для выбранной организации. Пример заголовка: `<OrganizationName> / Retail Price`'
      },
      orgWholesalePrice: {
        description: 'Устанавливает оптовую цену на уровне организации для выбранной организации. Пример заголовка: `<OrganizationName> / Wholesale Price`'
      },
      partNumber: {
        description: 'Уникальный идентификатор детали.'
      },
      retailPrice: {
        description: 'Устанавливает розничную цену на уровне участника.'
      },
      supplier: {
        description: 'Название поставщика детали.'
      },
      tagInternalName: {
        description: 'Назначает теги для детали. В заголовке должно быть указано внутреннее название тега. Для указания нескольких значений используйте разделитель (&#124). Пример: Красный &#124; Зеленый &#124; Синий.'
      },
      thumbnail: {
        description: 'Имя файла миниатюры. Допустимые расширения: .png, .jpg, .jpeg, .gif'
      },
      uom: {
        description: 'Единица измерения (например, «кажд. ", ед.»).'
      },
      visible: {
        description: 'Определяет, видима ли деталь. Допустимые значения: `true` или `false`. По умолчанию используется `true`.'
      },
      wholesalePrice: {
        description: 'Устанавливает оптовую цену на уровне участника.'
      }
    },
    showRequirements: 'Показать требования к XLSX',
    submitNote: 'Нажав кнопку «Отправить», вы запустите фоновую задачу и перейдете на страницу «Менеджер задач».',
    success: 'Задача массового импорта деталей создана',
    title: 'Массовый импорт деталей'
  },
  partsColumns: 'Колонки Деталей',
  partsDisplay: 'Отображение деталей',
  partsList: 'Список Деталей',
  partsListColumn: 'Колонка Списка Деталей | Колонки Списка Деталей',
  partsListData: 'Данные Списка Деталей',
  partsListGridHeader: 'Заглавие Таблицы Списка Деталей',
  partsNotSelected: 'Изображение по умолчанию используется для иконки детали. Если не используется оригинальная иконка, Documoto будет отображать стандартную иконку по умолчанию.',
  partsPage: 'Страница Деталей | Страницы Деталей',
  partsPageGroup: {
    columnsLoadErrorMsg: 'Не удалось загрузить колонки деталей',
    columnsUpdateErrorMsg: 'Произошла ошибка при попытке обновления Колонок Деталей',
    columnsUpdateSuccessMsg: 'Колонки Деталей обновлены',
    cropWhitespaceOnImages: 'Обрезать пустое пространство на изображениях',
    excludePartCodesFromPartsLists: 'Исключить Коды Деталей из Списка Деталей',
    highlightAlternateRows: 'Выделять Поочередные Ряды',
    keepBOMOnRight: 'Оставить BOM Справа',
    keepImagesOnLeft: 'Оставить Изображения Слева',
    printBorderAroundImages: 'Печатать Рамку Вокруг Изображений',
    printHotpointsOnImages: 'Печать Центральных Точек на Изображениях',
    rotateImagesAutomatically: 'Автоматически Вращать Изображения'
  },
  partsPages: 'Страницы Деталей',
  password: 'Пароль',
  passwordBlankMessage: 'Необходимо указать пароль',
  passwordCannotBeSame: 'Не должен совпадать с текущим паролем.',
  passwordCasingMassage: 'Должен содержать как минимум один символ в нижнем и один в верхнем регистре.',
  passwordCriteriaInfo: 'Новый пароль должен отвечать следующим условиям:',
  passwordExpiredHeader: 'Срок действия пароля истек',
  passwordExpiredInfo: 'Срок действия вашего пароля истек. Новый пароль должен отвечать следующим условиям:',
  passwordLowerCaseMessage: 'Пароль должен содержать по крайней мере один символ в нижнем регистре',
  passwordMinLengthMessage: 'Пароль должен содержать не менее 8 символов.',
  passwordNotMatchingMessage: 'Пароли не совпадают',
  passwordOptions: 'Параметры пароля',
  passwordOptionsRequired: 'Параметры пароля не могут быть пустыми',
  passwordSpecialCharactersMessage: 'Пароль должен содержать по крайней мере один специальный символ',
  passwordUpperCaseMessage: 'Пароль должен содержать по крайней мере один символ в верхнем регистре',
  passwordWillExpire1Day: 'Срок действия пароля для входа истекает менее чем через 1 день',
  passwordWillExpire5Days: 'Срок действия пароля для входа истекает менее чем через 5 дней',
  passwordsMatch: 'Пароли совпадают',
  pdfImport: {
    aiPdfImports: 'Импорт PDF с помощью ИИ',
    aiPdfImportsDescription: 'Управляйте импортом PDF-файлов с помощью ИИ, чтобы автоматически обрабатывать контент.',
    createImport: 'Новый импорт PDF через ИИ',
    createImportDescription: 'Выберите исходный PDF-файл и настройте параметры извлечения данных. Ограничения для файлов: размер до 500 МБ и не более 3000 страниц.',
    defaultPartNumberCode: 'Код номера детали по умолчанию',
    defaultTranslationLocale: 'Язык перевода по умолчанию',
    defaultUomHelpText: 'Используется, если столбец единиц измерения не сопоставлен или если в извлеченной строке спецификации нет значения единицы измерения.',
    defaultUomRequired: 'Обязательно, если не указана единица измерения',
    dropFileMessage: 'Перенесите файл сюда или нажмите для загрузки',
    fileSizeError: 'Размер файла превышает лимит в 500 МБ',
    importCreatedError: 'Не удалось создать импорт',
    importCreatedSuccess: 'Импорт успешно создан и добавлен в очередь на обработку',
    mapColumnToTag: 'Сопоставить столбец с тегом детали на странице',
    monthlyLimitExceeded: 'Будет превышен ваш месячный лимит страниц для импорта файлов PDF с помощью ИИ. Свяжитесь со своим менеджером по работе с клиентами, чтобы решить этот вопрос.',
    pageNumberFilterInvalidRange: 'Неверный диапазон номеров страниц',
    pageNumberFilterPlaceholder: '(например, 6, -7, 8-, 9-20)',
    partNumberCodeHelp: 'Код номера детали применяется к строкам спецификации, в которых поле «Номер детали» пустое',
    pdfImport: 'Импорт PDF | Импорты PDF',
    pdfImportsDescription: 'Чтобы автоматически извлекать данные о деталях из PDF-документов, управляйте импортом PDF с помощью ИИ',
    publishModalFooterHelp: 'С помощью кнопки «Опубликовать» можно добавить операцию в очередь, запустить ее в фоновом режиме и вернуться на страницу управления импортом файлов PDF с помощью ИИ, где вы сможете отслеживать статус публикации.',
    publishSkipAutoHotpointing: 'Пропустить автоматическое создание интерактивных зон на странице | Пропустить автоматическое создание интерактивных зон на страницах',
    publishingFinishedNone: 'Публикация импорта «{importName}» завершена. Ни одна страница не была опубликована.',
    publishingFinishedPartial: 'Публикация импорта «{importName}» завершена. Опубликовано страниц: {success}, не удалось опубликовать: {failed}. | Публикация импорта «{importName}» завершена. Опубликовано страниц: {success}, не удалось опубликовать: {failed}.',
    publishingFinishedSuccess: 'Публикация импорта «{importName}» завершена. Опубликовано страниц: {count}. | Публикация импорта «{importName}» завершена. Опубликовано страниц: {count}.',
    reviewStatusAll: 'Статус: Все',
    reviewStatusApproved: 'Утверждено',
    reviewStatusDropped: 'Удалено',
    reviewStatusNoStatus: 'Без статуса',
    reviewStatusNone: 'Нет',
    reviewStatusPending: 'В ожидании',
    selectPagePartTag: 'Выберите тег детали на странице',
    statusDeclined: 'Отклонено',
    statusFailed: 'Ошибка',
    statusPending: 'В ожидании',
    statusProcessing: 'Обработка',
    statusPublished: 'Опубликовано',
    statusPublishing: 'Публикуется',
    submitNote: 'С помощью кнопки «Опубликовать» можно добавить операцию в очередь, запустить ее в фоновом режиме и вернуться на страницу управления импортом файлов PDF с помощью ИИ, где вы сможете отслеживать статус импорта.'
  },
  pdfImportBom: {
    columnMatchStatus: 'Статус сопоставления',
    columnPagePartTag: 'Тег детали на странице',
    columnPartNameWithLocale: 'Название детали ({locale})',
    emptyState: 'Элементы спецификации не найдены',
    existingPartNameApplied: 'Применены существующие данные о деталях',
    title: 'Спецификация'
  },
  pdfImportIllustrations: {
    adjustBoundsButton: 'Настроить границы иллюстрации',
    boundsAdjusted: 'Границы изменены',
    emptyState: 'На этой странице нет иллюстраций.',
    hiresUnavailableError: 'Для этой страницы нет изображения в высоком разрешении.'
  },
  pdfImportOverview: {
    actionApproveSelected: 'Одобрить выбранные ({count})',
    actionClearStatusSelected: 'Сбросить статус для выбранных ({count})',
    actionCopySelected: 'Объединить в первую из выбранных страниц',
    actionDeleteImport: 'Удалить импорт PDF с помощью ИИ',
    actionDropSelected: 'Исключить выбранные ({count})',
    actionPendingSelected: 'Перевести выбранные в статус «В ожидании» ({count})',
    actionPublishSelected: 'Опубликовать выбранные',
    autoMergeAction: 'Автоматическое объединение страниц',
    autoMergeConfirmHelp: 'С помощью функции автоматического объединения можно найти страницы с одинаковыми названиями и объединить каждую группу совпадений в одну, первую страницу (в порядке визуального отображения). Исходные страницы, объединенные в целевую, будут помечены как исключенные. Проверьте результаты перед публикацией.',
    autoMergeConfirmTitle: 'Объединить страницы с совпадающими названиями?',
    autoMergeFailed: 'Не удалось выполнить автоматическое объединение, изменения не внесены',
    autoMergeSuccess: 'Автоматическое объединение завершено: объединено групп: {count}, исключено страниц: {dropped}',
    composedPageIndicator: 'Эта страница содержит контент, скопированный с других страниц в формате PDF.',
    contentTypeAll: 'Все типы контента',
    contentTypeBomOnly: 'Только спецификация',
    contentTypeBoth: 'Спецификация и иллюстрации',
    contentTypeEmpty: 'Пустые страницы',
    contentTypeFilterLabel: 'Тип контента',
    contentTypeIllustrationsOnly: 'Только иллюстрации',
    importSettings: 'Настройки импорта',
    includeDroppedPagesLabel: 'Включить исключенные страницы',
    incompleteBomFilterLabel: 'Показывать страницы с неполной спецификацией',
    mergeConfirmSourcePages: 'Выбрано {count} исходн. стр.: | Выбрано {count} исходн. стр.:',
    mergeConfirmTitle: 'Объединить выбранные страницы в первую из выбранных?',
    mergeConfirmTarget: 'Целевая страница: {pageLabel}',
    mergeFailed: 'Не удалось объединить страницы в первую выбранную страницу',
    mergeSuccess: 'Страницы объединены — целевая страница: {pageLabel} (элементов спецификации: {bomCount}, иллюстраций: {illustrationCount})',
    noPages: 'Нет доступных страниц',
    noPagesHint: 'Этот импорт не содержит страниц',
    noResults: 'Совпадающих страниц не найдено',
    noResultsHint: 'Попробуйте изменить поисковый запрос или фильтры',
    notificationLoadFailed: 'Не удалось загрузить обзор',
    notificationReviewStatusUpdated: 'Страниц успешно обновлено: {count}',
    notificationSelectAllFailed: 'Не удалось выбрать все страницы',
    notificationUpdateReviewStatusFailed: 'Не удалось обновить статус проверки',
    publishBookIdentifierNotUnique: 'Идентификатор книги должен быть уникальным.',
    publishBookIdentifierTakenHelp: 'Книга с таким идентификатором уже существует.',
    publishFailed: 'Не удалось опубликовать выбранные страницы',
    publishModalTitle: 'Опубликовать выбранные страницы',
    publishNewBookHelpText: 'Успешно опубликованные страницы добавятся в новую книгу в том же порядке, в котором они отображаются в сводке импорта PDF с помощью ИИ. Новая книга будет создана, только если хотя бы одна выбранная страница успешно опубликуется.',
    publishNewBookIdentifierLabel: 'Идентификатор книги',
    publishOptionNewBook: 'Создать новую книгу и добавить в нее страницы',
    publishOptionPagesOnly: 'Опубликовать только страницы',
    reviewManagement: 'Управление проверкой',
    reviewManagementTooltip: 'Используйте статусы проверки, чтобы организовать работу во время анализа извлеченного контента. Статусы «Одобрено», «В ожидании» и «Исключено» не влияют на публикацию. Их используют исключительно для отслеживания проверки.',
    reviewProgress: 'Прогресс проверки',
    title: 'Обзор'
  },
  pdfImportPageDetails: {
    actionPublish: 'Опубликовать страницу',
    firstPage: 'Первая страница',
    lastPage: 'Последняя страница',
    matchingPageNewPage: 'Новая страница деталей',
    matchingPageNewPageSharedSvg: 'Новая страница деталей, но файл в формате SVG также используется другими страницами',
    matchingPageOpenExisting: 'Открыть существующую страницу',
    matchingPageOverwrite: 'Существующая страница деталей будет перезаписана',
    navLabel: 'Сводка импорта PDF с помощью ИИ',
    navigationFailedText: 'Не удалось перейти на страницу {pageNumber}',
    nextPage: 'Следующая страница',
    notificationLoadFailed: 'Не удалось загрузить страницу',
    notificationPublishFailed: 'Не удалось отправить операцию публикации',
    notificationSaveFailed: 'Не удалось сохранить страницу',
    notificationSaveSuccess: 'Страница успешно сохранена',
    pageOriginComposed: 'Состоит из нескольких страниц в формате PDF',
    pageOriginExtracted: 'Извлечено из одной страницы в формате PDF',
    pageOriginLabel: 'Источник страницы',
    previousPage: 'Предыдущая страница',
    publishPageModalHelpText: 'Эта страница деталей будет опубликована вне контекста книги. При публикации будет создана новая страница деталей либо перезаписана существующая (в соответствии с правилами идентификации страниц).',
    thumbnailCardTitle: 'Миниатюра страницы в формате PDF',
    viewBom: 'Спецификация'
  },
  pdfImportPublishingHistory: {
    bookResultCreated: 'Создано',
    columnPdfPage: 'Страницы в формате PDF',
    columnPublishingStatus: 'Статус публикации',
    detailLoadFailed: 'Не удалось загрузить сведения об операции публикации',
    emptyBookOperations: 'В этой операции не выполнялись действия с книгами.',
    emptyJobsHint: 'Информация о публикациях появится здесь после того, как страницы будут опубликованы.',
    emptyJobsTitle: 'Для этого импорта PDF с помощью ИИ операции публикации еще не выполнялись.',
    emptyPagesTitle: 'Нет страниц, соответствующих выбранному фильтру.',
    filterAllPages: 'Показывать все страницы',
    filterFailedOnly: 'Показывать только страницы с ошибками',
    filterNameQuery: 'Название или файл страницы',
    filterPublishedOnly: 'Показывать только опубликованные страницы',
    helpText: 'На этой странице отображается история страниц деталей, опубликованных из этого импорта PDF с помощью ИИ, включая страницы, которые были созданы, перезаписаны или не опубликованы из-за ошибок во время процесса.',
    jobLabel: 'Операция № {number}',
    loadFailed: 'Не удалось загрузить историю публикаций',
    resultPublishedCreated: 'Опубликовано — Создано',
    resultPublishedUpdated: 'Опубликовано — Перезаписано',
    resultSummaryBookCreated: 'Создана новая книга.',
    resultSummaryNone: 'Нет опубликованных страниц.',
    resultSummaryPagesFailed: 'Не удалось опубликовать {n} стр. | Не удалось опубликовать {n} стр.',
    resultSummaryPagesPublished: 'Опубликовано страниц: {n}. | Опубликовано страниц: {n}.',
    statusFailed: 'Ошибка',
    statusInProgress: 'В процессе',
    title: 'История публикаций'
  },
  permission: 'Право доступа | Права доступа',
  phoneNumber: 'Номер Телефона',
  phoneNumberExt: 'Добавочный',
  phonePrimary: 'Основной Номер Телефона',
  phoneSecondary: 'Дополнительный Номер Телефона',
  pinFilter: 'Закрепить фильтр для поиска на странице результатов',
  pinned: 'Закрепленный',
  plusMoreOrgs: '+ {totalOrgCount} дополнительных Организаций',
  polishDescription: 'Описание На Польском',
  polishName: 'Название На Польском',
  populatePdfNameSelection: 'Заполните поле «Выбор имени файла в формате PDF»',
  populatePdfNameWith: 'Заполните поле «Имя файла в формате PDF»',
  port: 'Порт',
  portrait: 'Портрет',
  portugueseDescription: 'Описание На Португальском',
  portugueseName: 'Название На Португальском',
  postComment: 'Опубликовать Комментарий',
  postalCode: 'Почтовый Индекс',
  poweredBy: 'При поддержке',
  preferences: 'Предпочтения',
  preferencesDisable: 'Отключить Настройки Пользователя',
  prefix: 'Префикс | Префиксы',
  preview: 'Предварительный просмотр',
  previewOfName: 'Предварительный просмотр {name}',
  pricing: 'Цены',
  pricingDiscountEnabled: 'Отобразить Цену со Скидкой',
  pricingDisplayInCart: 'Отобразить Цены в Корзине',
  pricingDisplayInPartsList: 'Отображать Цены в Списке Деталей',
  pricingGlobal: 'Глобальные Цены',
  pricingGlobalDescription: 'Обычная цена, когда нет перезаписи Организации',
  pricingHideInitially: 'Скрывать цену изначально',
  pricingHidePricingButton: 'Включить Кнопку «Спрятать Цены»',
  pricingHidePricingButtonDisable: 'Выключить Кнопку «Спрятать Цены»',
  pricingHidePricingButtonDisableHelp: 'Если отключить кнопку «Скрыть цену», пользователи не смогут самостоятельно показывать или скрывать уровни цен. Любой уровень цен, для которого включена опция «Скрывать цену изначально», останется скрытым, и пользователи не смогут его отобразить.',
  pricingOrganization: 'Цены Организации',
  pricingOrganizationDeleteConfirm: 'Вы уверены, что хотите удалить цены Организации?',
  pricingOrganizationDescription: 'Цены организации перезаписывают глобальные цены для всех пользователей в Организации и в их дочерних Организациях.',
  pricingOrganizationDuplicate: 'Эта организация уже была перезаписана',
  pricingOrganizationEmptyState: 'Не установлены параметры перезаписи для организации. Нажмите {add}, чтобы начать.',
  pricingRetailEnabled: 'Отобразить Розничную Цену',
  pricingWholesaleEnabled: 'Отобразить Оптовую Цену',
  primary: 'Основное',
  print: 'Печать',
  printJob: 'Операция на Печать',
  printLogo: 'Логотип для печати',
  printSetting: 'Настройки Печати',
  printSettingCopyMessage: 'Введите уникальное имя для Настроек Печати.',
  printSettingCreated: 'Созданы Настройки Печати',
  printSettingDeleteFail: 'Не удалось Удалить Настройки Печати',
  printSettingEmptyMessage: 'Не заданы Настройки Печати. Добавьте Настройки Печати, чтобы начать.',
  printSettingSaveFail: 'Не удалось Сохранить Настройки Печати',
  printSettingSelectionRequired: 'Необходимо выбрать настройки печати.',
  printSettingSetDefaultSuccess: 'Настройки Печати по умолчанию установлены',
  printSettingUpdateFail: 'Не удалось Обновить Настройки Печати',
  printSettings: 'Настройки Печати',
  printSettingsLogo: 'Логотип Настроек Печати',
  printerLane: 'Дорожка принтера',
  printing: 'Печать',
  printingDisabled: 'Запретить Всю Печать',
  privacyPolicy: 'Политика Конфиденциальности',
  proceed: 'Продолжить',
  process: 'Обработать',
  processContent: 'Обработать Контент',
  processToDraft: 'Обработка с созданием черновика',
  processedPlzToDraft: 'PLZ-файлы, обработанные с созданием черновиков',
  processing: 'Обработка',
  productCategory: 'Категория продукта | Категории продуктов',
  productCategoryName: 'Название категории продукта',
  productId: 'Идентификатор продукта',
  productIdErrorMessage: 'Укажите идентификатор продукта',
  productIdMessage: 'Значение идентификатора, по которому пользователи будут находить продукт, например «FTX1000»',
  productPage: 'Страница продукта | Страницы продукта',
  productPageAccessControlDescription: 'Настройки управления доступом определяют, кто может видеть эту страницу, на основе назначений организаций и групп пользователей.',
  productPageCreated: 'Страница продукта создана',
  productPageDescription: 'Описание страницы продукта',
  productPageIdentifierMessage: 'Уникальный внутренний идентификатор для этой страницы',
  productPageName: 'Название страницы продукта',
  productPageProductId: 'Идентификатор продукта на его странице',
  productPageUpdated: 'Страница продукта обновлена',
  productPagesBulkImport: {
    description: 'Загрузите файл данных, чтобы запустить массовый импорт страниц товаров. Поддерживаемый формат файлов: XLSX.',
    downloadUnprocessedRows: 'Загрузить таблицу необработанных строк',
    overwriteAccessControls: 'Перезаписать настройки доступа (организаций и групп пользователей)',
    overwriteAssociatedMedia: 'Перезаписать связанные медиафайлы',
    requirements: {
      enUSCategory: {
        description: 'Существующее название категории продуктов для выбранного языка. См. наше <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">руководство по языковой поддержке</a>.'
      },
      enUSDescription: {
        description: 'Перевод описания страницы продукта для конкретного языка. См. наше <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">руководство по языковой поддержке</a>.'
      },
      enUSName: {
        description: 'Перевод названия страницы продукта для конкретного языка. Для новых страниц продуктов необходимо указать как минимум один перевод. См. наше <a href="https://support.documoto.com/knowledge-base/documoto-language-support" target="_blank" rel="noopener noreferrer">руководство по языковой поддержке</a>.'
      },
      identifier: {
        description: 'Уникальный идентификатор страницы продукта, который виден и доступен для поиска только в Центре администрирования.'
      },
      media: {
        description: 'Список идентификаторов медиафайлов, связанных с определенной страницей продукта. Для указания нескольких значений используйте разделитель (&#124).'
      },
      organizations: {
        description: 'Список организаций, имеющих доступ к определенной странице продукта. Для указания нескольких значений используйте разделитель (&#124).'
      },
      productId: {
        description: 'Идентификатор страницы продукта для конечных пользователей, который отображается и доступен для поиска в библиотеке. Уникальность идентификатора продукта необязательна.'
      },
      tagInternalName: {
        description: 'Назначает теги для страницы продукта. В заголовке должно быть указано внутреннее название тега. Для указания нескольких значений используйте разделитель (&#124). Пример: Красный &#124; Зеленый &#124; Синий.'
      },
      thumbnail: {
        description: 'Имя файла миниатюры. Допустимые расширения: .png, .jpg, .jpeg, .gif'
      },
      userGroups: {
        description: 'Список групп пользователей, имеющих доступ к определенной странице продукта. Для указания нескольких значений используйте разделитель (&#124).'
      }
    },
    success: 'Создана операция массового импорта страниц продуктов',
    title: 'Массовый импорт страниц продуктов'
  },
  production: 'Производство',
  professional: 'Профессиональный',
  profile: 'Профиль',
  prohibitExportDownloadOfContent: 'Запретить экспорт/скачивание содержимого',
  prohibitExportDownloadOfContentHelpText: 'Если выбран вариант "Включить", пользователи (обладающие правами) не смогут экспортировать или скачивать это содержимое.',
  property: 'Свойство | Свойства',
  province: 'Область',
  'public': 'Публичный',
  publish: 'Опубликовать',
  publishDocuments: 'Опубликовать Документы',
  publishDraft: 'Опубликовать Черновик',
  publishThumbnailJob: 'Опубликовать Эскиз',
  publisher: 'Публикатор | Публикаторы',
  publisherJob: 'Операция Публикатора',
  publisherLane: 'Дорожка издателя',
  publisherManualLane: 'Дорожка издателя (вручную)',
  publisherMessage: 'Создание контента, управление контентом и настройки печати',
  publishingErrors: 'Ошибки Публикации',
  publishingErrorsWithName: 'Ошибки Публикации {name}',
  publishingInProgress: 'Не удалось отправить, выполняется публикация',
  purchaseOrder: 'Заказ на Поставку',
  purchaseOrderTemplateDisabled: 'Выключить Шаблоны Заказа',
  purchaseOrderTemplateEnabled: 'Включить Шаблоны Заказа',
  qty: 'Кол-во',
  quantity: 'Количество',
  query: 'Запрос',
  quickAdd: 'Быстрое Добавление',
  quickAddHelpText: 'Начните вводить текст, чтобы найти детали для добавления в корзину.',
  quickAddInCartEnabled: 'Включить Быстрое Добавление в Корзине',
  quickLinks: 'Быстрые Ссылки',
  quote: 'Цитата | Цитаты',
  quoteFormType: 'Форма коммерческого предложения',
  quoteTemplateDisabled: 'Выключить Шаблоны Расценки',
  quoteTemplateEnabled: 'Включить Шаблоны Расценки',
  range: 'Диапазон',
  rearrange: 'Перестроить',
  rebuildIndexJob: 'Перестройка Индекса',
  recentSearches: 'Недавние поисковые запросы',
  recentlyAdded: 'Недавно Добавлено',
  recentlyEdited: 'Недавно Отредактировано',
  recentlyViewed: 'Недавно Просмотрено',
  recipientOrRecipients: 'Получатели',
  rectangle: 'Прямоугольник',
  redirect: 'Перенаправить',
  refresh: 'Обновить',
  related: 'Похожее',
  relatedDescription: 'Свяжите существующие медиа в библиотеке с этим элементом «{type}». Обратите внимание, что связанные медиа должны иметь активные настройки управления доступом, чтобы пользователи могли видеть их на вкладке \'Похожее\'.',
  relatedInfo: 'Сопутствующая Информация',
  relatedView: 'Просмотреть Похожие Медиа',
  relationship: 'Отношения | Отношения',
  releaseNotes: 'Примечания к Версии',
  remainingWidth: 'Остаточная Ширина',
  rememberMe: 'Запомнить меня',
  remove: 'Удалить',
  removeAll: 'Удалить Все',
  removeItemConfirmation: 'Вы уверены, что хотите удалить {item}?',
  removeItemCount: 'Действительно удалить {count} {type}?',
  replace: 'Заменить',
  replaceExisting: 'Заменить Существующее',
  report: 'Отчет | Отчеты',
  reportAnIssue: 'Сообщить о Проблеме',
  reportAnIssueMessage: 'Письмо успешно отправлено.',
  reportCatalogName: 'Имя Каталога Отчетов',
  reportCatalogNotSet: 'Каталог отчетов не был определен для данного отчета.',
  reportDefinition: 'Определение Отчета | Определения Отчета',
  reportDefinitionDeleteError: 'Не удалось удалить определение отчета',
  reportExportTimeWarning: 'В зависимости от количества записей и выбранного формата операция экспорта может занять несколько минут.',
  reportSettings: 'Настройки Отчетов',
  reporting: 'Отчетность',
  reportingMessage: 'Доступ к различным отчетам и статистике',
  reportsEmptyState: 'Отчетов нет',
  reportsLibrary: 'Библиотека Отчетов',
  requestForQuote: 'Запрос Ценового Предложения',
  requestFormType: 'Форма коммерческого предложения',
  requireAuthentication: 'Обязательная Идентификация',
  required: 'Обязательный',
  requiredField: 'Обязательное Поле',
  requiredItem: 'Необходим {item}.',
  requiredMessage: '{item} обязательный.',
  requiredMessageAndUnique: 'Элемент «{item}» является обязательным и должен быть уникальным.',
  requiredReading: 'Обязательное Чтение',
  requiredReadingMessage: 'Просмотрите следующее:',
  requiredType: 'Укажите тип.',
  requiredUrlMessage: 'Необходима правильно оформленная ссылка.',
  reset: 'Сброс',
  resetPassword: 'Сбросить Пароль',
  resetPasswordError: 'Не удалось сбросить пароль. Повторите попытку.',
  resetPasswordTokenError: 'Маркер сброса пароля недействителен.',
  resetZoom: 'Сброс Масштабирования',
  resize: 'Изменить размер',
  resizeThumbnails: 'Автоматически изменять размер эскизов',
  resource: 'Ресурс | Ресурсы',
  result: 'Результат | Результаты',
  resultFor: 'Результат для {item} | Результаты для {item}',
  retail: 'Розница',
  retailPrice: 'Розничная Цена',
  retailTotal: 'Суммарная Розничная Цена',
  'return': 'Вернуться',
  returnToItem: 'Вернуться к {item}',
  returnToMedia: 'Вернуться к Медиа',
  returnToPartList: 'Вернуться к Списку Деталей',
  returnToTemplate: 'Вернуться к Шаблону',
  returnToViewer: 'Перейти к окну просмотра',
  revert: 'Отменить',
  revertChanges: 'Отменить Изменения',
  revertChangesMsg: 'Отменить изменения?',
  right: 'Справа',
  romanianDescription: 'Описание На Румынском',
  romanianName: 'Название На Румынском',
  rootLevelBrowseFlow: 'Корневой Уровень',
  row: 'Ряд',
  russianDescription: 'Описание На Русском',
  russianName: 'Название На Русском',
  s3DataExportsEnabled: 'Включить экспорт данных в S3',
  sampleData: 'Образец Данных',
  samplePreview: 'Предварительный просмотр образца',
  sandbox: 'Песочница',
  sat: 'Сб',
  save: 'Сохранить',
  saveAndClose: 'Сохранить и закрыть',
  saveAndEditTarget: 'Сохранить и отредактировать целевое значение',
  saveChanges: 'Сохранить изменения в {item}? {name}',
  saveChangesToItem: 'Сохранить изменения в {item}?',
  saveNewAPIKey: 'Новый Ключ Интеграции не сохранен; Вернитесь для завершения настройки',
  saveNewWidgetKey: 'Не удалось сохранить новый ключ виджета. Вернитесь к завершению настройки.',
  saveOrderAttachmentsError: 'Не удалось сохранить вложения к заказу.',
  saved: 'Сохранено',
  search: 'Поиск',
  searchAllContent: 'Поиск по всему содержимому',
  searchCategories: 'Категории',
  searchConfiguration: 'Конфигурация поиска',
  searchContent: 'Искать {content}',
  searchCriteria: 'Критерии Поиска',
  searchDocumoto: 'Искать на Documoto',
  searchFeatures: 'Функции поиска',
  searchFieldConfigDescription: 'Нижеуказанные параметры поиска в системных полях применимы только к странице результатов поиска, а также к инструментам «Общий поиск по библиотеке» и «Быстрое добавление в корзину». Других функций поиска (например, «Поиск в центре администрирования» и «Библиотека использования») это не касается.',
  searchInContent: 'Поиск в {contentName}...',
  searchPlaceholder: 'Поиск по всему содержимому…',
  searchPrompt: 'Поиск по всему содержимому…',
  searchProperty: 'Свойство Поиска | Свойства Поиска',
  searchResults: 'Результаты поиска',
  searchResultsConfiguration: 'Конфигурация результатов поиска',
  searchSettings: 'Параметры поиска',
  searchSettingsDescription: 'Эти параметры управляют использованием, функциями и результатами поиска по Библиотеке.',
  searchTerm: 'Искать Термин',
  searchTips: 'Советы по поиску:',
  searchType: 'Тип',
  searchable: 'С возможностью поиска',
  searchableFieldsSuccessfullyUpdated: 'Поля, доступные для поиска, успешно обновлены.',
  searchableTag: 'Тег с возможностью поиска',
  searchingInLanguage: 'Поиск только в {lang}',
  searchingInTwoLanguages: 'Поиск только в {lang1} и {lang2}',
  section: 'Раздел',
  select: 'Выбрать',
  selectAField: 'Выберите поле {field}',
  selectAll: 'Выбрать Все',
  selectAndClose: 'Выбрать и Закрыть',
  selectChapters: 'Выбрать Главу (-ы)',
  selectChildren: 'Выбрать Дочерние элементы',
  selectFields: 'Выбрать поля {fields}',
  selectItem: 'Выбрать {item}',
  selectMedia: 'Выбрать Носитель',
  selectPage: 'Выбрать Страницу',
  selectPages: 'Выбрать Страницу (-ы)',
  selectTargetPage: 'Выбрать Целевую Страницу',
  selected: 'Выбрано',
  selectedTargetPage: 'Выбранная Целевая Страница',
  send: 'Отправить',
  sendReverificationEmail: 'Отправить письмо для повторного подтверждения',
  sendVerificationEmail: 'Отправить письмо для подтверждения',
  september: 'Сентябрь',
  sequence: 'Последовательность',
  serbianDescription: 'Описание На Сербском',
  serbianName: 'Название На Сербском',
  serviceUri: 'Сервисная ссылка',
  sessionLog: 'Журнал сеансов',
  set: 'Установить',
  setAsDefault: 'Установить По умолчанию',
  setPassword: 'Установить пароль',
  settings: 'Настройки',
  settingsMessage: 'Обновите свои параметры пользователя и пароль',
  shape: 'Форма',
  shapeTool: 'Инструмент “Фигура”',
  shared: 'Общий доступ',
  sharedCart: 'Совместная Корзина | Совместные Корзины',
  sharedCartDeleteContent: 'Это удалит Совместную Корзину для всех Организаций, для которых она была создана.',
  sharedCartOrganizationContent: 'Выберите Организации, которые могут использовать эту Совместную Корзину.',
  sharedShoppingCartsEnabled: 'Включить Совместные Корзины',
  shoppingCartExportJob: 'Экспорт Корзины Покупок',
  shoppingCartLoadingLongTime: 'Корзина загружается. Значки корзины появятся после завершения процесса. Если проблема сохраняется, обратитесь за поддержкой к администратору Documoto.',
  showChapterTOCForHiddenPages: 'Показать Главу с Содержанием для Скрытых Страниц',
  showExportFromSearch: 'Разрешить Экспорт из Результатов Поиска',
  showExportFromSearchHelp: 'Разрешить экспорт списка книг, показанных в результатах поиска',
  showHelp: 'Показать Справку',
  showIdentifierInLibrary: 'Показывать идентификаторы медиафайлов и страниц продуктов в библиотеке',
  showIdentifierInSearch: 'Показать идентификатор медиа в поиске',
  showItem: 'Показать {item}',
  showLess: 'Показать Меньше',
  showMediaDescriptionFilter: 'Показать Фильтр Описания Медиа',
  showMediaIdentifierFilter: 'Показать Фильтр Идентификации Медиа',
  showMediaNameFilter: 'Показать Фильтр Имени Медиа',
  showMore: 'Показать Больше',
  showOnlyExactMatches: 'Показывать только точные совпадения',
  showOrganizationFilter: 'Показать Фильтр Организации',
  showPartNameFilter: 'Показать Фильтр Имени Детали',
  showPartNumberFilter: 'Показать Фильтр Номера Детали',
  showRecentlyAdded: 'Показать Недавно Добавленное',
  showRecentlyViewed: 'Показать Недавно Просмотренное',
  showSearchButton: 'Показать Кнопку Поиска на Домашней Странице',
  showSearchButtonHelp: 'Показать кнопку \'Перейти к Поиску\' в верхнем меню Библиотеки',
  signature: 'Подпись',
  size: 'Размер',
  snapshot: 'Мгновенный снимок | Мгновенные снимки',
  solrSlaveSvrOverride: 'Переопределение базовых URL подчиненных серверов SOLR',
  sortAsc: '{value} A–Я',
  sortDesc: '{value} Я–A',
  sortRelevant: 'Самое Актуальное',
  sortType: 'Сортировать по Типу',
  sourceBrowseFlow: 'Исходный поток просмотра',
  sourceFile: 'Исходный файл',
  sourceFilename: 'Название исходного файла',
  spanishDescription: 'Описание На Испанском',
  spanishName: 'Название На Испанском',
  square: 'Квадрат',
  ssoConfiguration: 'Конфигурация SSO',
  ssoIdpMetadataUrl: 'URL метаданных IDP SSO',
  ssoLoginMaxAuthenticationAgeSeconds: 'Максимальный срок аутентификации входа SSO, в секундах',
  ssoSamlDnAttributeName: 'Имя атрибута DN SAML SSO',
  ssoSamlEmailAttributeName: 'Имя атрибута электронной почты SAML SSO',
  ssoSamlMemberofAttributeName: 'Имя атрибута участника SAML SSO',
  ssoSniForSsoMetadataRetrieval: 'Использовать SNI для получения метаданных SSO',
  standard: 'Стандарт',
  standardUserGroup: 'Стандартная группа пользователей',
  startDate: 'Дата Начала',
  startDateRequired: 'Требуется указать дату начала.',
  state: 'Состояние',
  'static': 'Статический',
  status: 'Статус',
  statusCode: 'Код Статуса | Коды Статуса',
  stitchPages: 'Сшитые Страницы',
  storeFilterValues: 'Сохранить значения фильтров',
  storeFilterValuesDescription: 'Если включить этот параметр, будут сохраняться значения, установленные пользователями в фильтрах страницы поиска для этого тега.',
  storeFrontAdmin: 'Администратор онлайн-магазина',
  storefront: 'Онлайн-магазин',
  storefrontIntegration: 'Интеграция онлайн-магазина | Интеграции онлайн-магазина',
  storefrontIntegrationSubtitle: 'Эти настройки контролируют разные элементы и опции Интеграции Онлайн-магазина. С осторожностью применяйте изменения. Обратитесь в Службу Поддержки Documoto для получения подробной Информации.',
  storefrontSettings: 'Настройки Онлайн-магазина',
  storefrontSettingsDescription: 'Эти настройки контролируют разные элементы и опции Онлайн-магазина. С осторожностью применяйте изменения. Обратитесь в Службу Поддержки Documoto для получения подробной информации.',
  storefrontSettingsOrgDescription: 'Эти настройки контролируют разные элементы и опции Онлайн-магазина на уровне Организации. С осторожностью применяйте изменения. Обратитесь в Службу Поддержки Documoto для получения подробной информации.',
  stroke: 'Штрих',
  style: 'Стиль | Стили',
  styles: {
    colorHotpoint: 'Основная точка по умолчанию',
    inheritedFromOrg: 'Унаследовано от организации {org}',
    inheritedFromSystem: 'Унаследовано от системного значения по умолчанию',
    inheritedFromTenant: 'Унаследовано от арендатора',
    invalidHexcode: 'Недействительный шестнадцатеричный код',
    organization: 'Стиль организации | Стили организации',
    organizationSaved: 'Стили организации сохранены',
    sampleNavigation: 'Навигационные вкладки',
    samplePrimary: 'Навигация/Кнопки',
    sampleSelectedHotpoint: 'Выбранные основные точки',
    tenant: 'Стиль арендатора | Стили арендатора',
    tenantSaved: 'Стили арендатора сохранены'
  },
  subChapter: 'Подраздел | Подразделы',
  subject: 'Тема',
  subjectMessage: 'Необходимо указать Тему',
  submit: 'Отправить',
  submitPurchaseOrder: 'Заказ на поставку',
  submitRequestForQuote: 'Запрос Ценового предложения',
  submitted: 'Отправлено',
  submittedBy: 'Отправил(-а)',
  submittedFilesMessage: 'Отправлено файлов: {fileCount}.',
  submitter: 'Отправитель',
  submitterEmail: 'Адрес электронной почты отправителя',
  submitterFirstName: 'Имя отправителя',
  submitterLastName: 'Фамилия отправителя',
  submitterOrgName: 'Название организации отправителя',
  submitterUserName: 'Имя пользователя отправителя',
  success: 'Успех',
  successNotificationDuration: 'Добавить в Корзину — Продолжительность Всплывающего Уведомления об Успешном выполнении',
  suffix: 'Суффикс | Суффиксы',
  suggestedKeywords: 'Рекомендуемые ключевые слова',
  suggestedResults: 'Рекомендуемые результаты',
  suggestion: 'Предложение | Предложения',
  sun: 'Вс',
  superAdminSettings: 'Настройки суперадминистратора',
  superadmin: 'Суперадминистратор',
  supersede: 'Заменить',
  supersedeComplete: 'Вы хотите завершить замену?',
  supersedeDiscardChanges: 'Отменить вашу замену?',
  supersedeMainText: 'Замена заменяет существующую деталь одной или несколькими деталями на каждой Странице Деталей, где найдена старая деталь. Старый номер детали удалится, но останется в поиске по средствам тегов, и таким образом контент можно найти, используя старый номер или новый(е) номер(а).',
  supersedeMessage: 'Обновления информации о деталях будут сразу применены. Поиск отобразит обновления через несколько минут.',
  supersedeNotProcessed: 'Ваша замена не будет обработана.',
  supersedeReplacePart: 'Найти одну или более деталей, которые заменят деталь',
  supersedeSuccessful: 'Замена прошла Успешно',
  supersedeWith: 'Заменить Деталь На…',
  superseded: 'Заменено',
  supersededParts: 'Замененные детали',
  supplier: 'Поставщик | Поставщики',
  supplierDescription: 'Компания, которая поставляет эту деталь',
  supplierKey: 'Ключ поставщика',
  supportedDraftArchives: 'Неподдерживаемый файл; поддерживаемые файлы черновиков: MDZ, PLZ',
  supportedImageFormats: 'Форматы изображения, которые поддерживаются: GIF, JPG, JPEG, PNG',
  surroundWithQuotes: 'Для нахождения точных совпадений заключите поисковые термины в кавычки.',
  svgFinder: 'Система поиска SVG',
  swedishDescription: 'Описание На Шведском',
  swedishName: 'Название На Шведском',
  system: 'Система',
  systemAdmin: 'Системный Администратор',
  systemFieldSearchAndFiltering: 'Поиск и фильтрация системных полей',
  systemFields: 'Системные Поля',
  systemName: 'Название системы',
  systemStatus: 'Системный Статус',
  systemVersion: 'Версия системы',
  tabDelimited: 'с разделителями-знаками табуляции',
  tableOfContents: 'Оглавление',
  tabloid: 'Формат «Tabloid»',
  tag: 'Тег | Теги',
  tagDeleteAffectedCount: 'Это удалит тег и информацию о теге из {count} наименований(я).',
  tagDeleteAffectedNone: 'Нет наименований, которые используют этот тег.',
  tagEditor: {
    filterPrompt: 'Отображение первых 100 значений. Используйте фильтр, чтобы увидеть больше.',
    rangeBoundLengthInvalid: 'Значение не должно превышать ограничение по символам: {limit}.',
    tagEditorModal: 'Редактор Тегов',
    textfieldHelpText: 'Введите одно или несколько значений, разделяя их точками с запятой. Пример: SN001; SN002'
  },
  tagManagerDeleteWarning: 'Все существующие медиа с {deleteCategoryName} утратят эту категорию после удаления.',
  tagName: 'Название тега',
  tagSearchAndFiltering: 'Поиск и фильтрация тегов',
  tagSearchAndFilteringHelpText: 'Подсказка: Некоторые параметры поиска и фильтров также можно настроить в «Редакторе тегов» инструмента «Менеджер тегов», который можно найти здесь: ',
  tagSubmitAffected: 'Любой контент {type} будет автоматически сбрасывать тег {tag} вместе с изменениями.',
  tagValue: 'Значение тега | Значения тега',
  tagValueMissing: 'Вам нужно ввести значение тега',
  tagValueMultiple: 'Разделитель точка с запятой для множественного ввода',
  tagValueTooLong: 'Значение тега превышает лимит в 25 символов | Значения тега превышают лимит в 25 символов',
  tagsDeleteError: 'Не удалось удалить один или несколько тегов',
  tagsDeleteSuccess: 'Теги удалены',
  tagsDisplayMore: 'Отображение первых 100 значений. Используйте фильтр, чтобы увидеть больше.',
  tagsManager: 'Тег-менеджер',
  tagsSaveError: 'Не удалось сохранить один или несколько тегов',
  tagsSaveSuccess: 'Теги сохранены',
  tagsUpdateError: 'Не удалось обновить один или несколько тегов',
  tagsUpdateSuccess: 'Теги обновлены',
  targetBrowseFlow: 'Целевой поток просмотра',
  taxon: 'Таксон',
  taxonomy: 'Таксономия',
  template: 'Шаблон | Шаблоны',
  templateEmailRecipients: 'Шаблон Получателей Электронного Письма',
  templateLayout: {
    addItem: 'Добавить элемент',
    addRow: 'Добавить строку',
    deleteColumn: 'Удалить столбец',
    deleteRow: 'Удалить строку',
    fullWidth: 'Полная ширина',
    oneColumn: 'Один столбец',
    threeColumns: 'Три столбца',
    twoColumns: 'Два столбца'
  },
  tenant: 'Участник | Участники',
  tenantAdmin: 'Администратор Участников',
  tenantAdminMessage: 'Управляет настройками всех участников',
  tenantCleanerJob: 'Обслуживание Клиентов',
  tenantConfiguration: 'Конфигурация участника',
  tenantEmailRecipients: 'Получатели Электронного Письма для Участников',
  tenantEmailRecipientsOverrideMessage: 'Это будет перезаписано, если указаны Получатели Электронного Письма Организации',
  tenantIndexQueueJob: 'Очередь Индексов Клиентов',
  tenantKey: 'Ключ участника',
  tenantKeyError: 'Ключ участника не является уникальным',
  tenantKeyMessage: 'Ключ участника должен быть уникальным',
  tenantLabelDeleteMessage: 'Удаление этого ярлыка вернет имя Documoto по умолчанию.',
  tenantLabelsPageText: 'Ярлыки используются для персонализации имен многих объектов, которые будут найдены в Библиотеке Documoto, и на Администраторской панели.',
  tenantPrintSettingsDescription: 'Выберите настройки печати по умолчанию для всех участников. Это будет применено ко всем печатным книгам, за исключением тех, которые были исключены в Организации и Медиа.',
  tenantReindexModulus: 'Модуль реиндексирования участника',
  tenantSettings: {
    collapseTOCLabel: 'Свернуть Оглавление на Подходящей Странице',
    defaultLocaleLabel: 'Регион по умолчанию',
    defaultLocaleMessage: 'Регион участника по умолчанию.',
    defaultSupplierLabel: 'Поставщик по умолчанию.',
    defaultSupplierMessage: 'Поставщик участника по умолчанию.',
    deleteMissingTranslationsOnPublishLabel: 'Удалить отсутствующие переводы при публикации?',
    deleteMissingTranslationsOnPublishMessage: 'Если этот параметр включен, переводы компонентов удаляются при публикации',
    enableChapterIndexingLabel: 'Включение индексирования разделов медиа',
    enableChapterIndexingMessage: 'Индексировать разделы',
    enableIndexingLabel: 'Указатель Публикаций',
    enableIndexingMessage: 'Включает отображение указателя для публикации.',
    excludePartsFromAccessControlChecksLabel: 'Исключить детали из правил управления доступом',
    excludePartsFromAccessControlChecksMessage: 'Если эта функция включена, детали будут видны всем пользователям, независимо от правил доступа к медиафайлам.',
    exportPgAsHashLabel: 'Экспортировать имя файла страницы в виде хеш-ключа',
    exportPgAsHashMessage: 'Использовать хеш-ключи в качестве имен файлов страниц в экспортированном содержимом',
    helpUrlLabel: 'Ссылка «Помощь» по умолчанию',
    helpUrlMessage: 'Ссылка для альтернативной системы поддержки.',
    hotPointLinkPageInBookOnlyLabel: 'Страница со Ссылками Hotpoint Только в Книге',
    hotPointLinkPageInBookOnlyMessage: 'Ссылки Hotpoint на Страницах Только в Книге',
    lockPartTrOnPublishLabel: 'Блокировать переводы компонентов при публикации',
    lockPartTrOnPublishMessage: 'Позволяет запретить изменение переводов компонентов во время публикации',
    mediaTimestampLabel: 'Обновить Отметку Времени для Медиа на Панели Управления Доступом',
    mediaTimestampMessage: 'Включите, если изменение категорий носителей контроля доступа должно приводить к обновлению временной метки носителя.',
    publisherDefaultUom: 'Единицы Измерения Публикатора По умолчанию',
    publishingContactLabel: 'Публикация Контактного Электронного Адреса',
    publishingContactMessage: 'Электронный адрес по умолчанию, который будет получать сообщения при уведомлении о проблеме с контентом.',
    replaceHotpointLabel: 'При Публикации всегда Заменяйте Ссылки-якоря',
    replaceHotpointMessage: 'Только для публикации в Docustudio.',
    ssoLoginSystemLabel: 'Система Входа SSO',
    ssoLoginSystemMessage: 'Система Поставщика Идентификационной информации для SSO.',
    userPasswordExpirationLabel: 'Срок действия пароля, дни',
    userPasswordExpirationMessage: 'Количество дней, по истечении которого пароль необходимо изменить; если это поле пустое, срок действия пароля не истекает'
  },
  tenantSettingsSaved: 'Настройки Участника Сохранены',
  tenantSettingsSubtitle: 'Эти настройки управляют свойствами и поведением на уровне участников. Применяйте изменения осторожно. Чтобы узнать больше, обратитесь в Службу Поддержки Documoto.',
  tenantSettingsTitle: 'Настройки Участника',
  tenantSuppliers: 'Поставщики участников',
  tenantType: 'Тип участника',
  tenantWebserviceUser: 'Пользователь веб-службы участника',
  text: 'Текст',
  textArea: 'Область Текста',
  textColor: 'Цвет текста',
  textField: 'Текстовое Поле',
  textFile: 'Текстовый Файл (CSV, TXT)',
  textTool: 'Инструмент “Текст”',
  threeD: {
    addFile: 'Добавить файл детали в 3D',
    beforeSaveModal: {
      message: 'Заменить этот файл повсюду или прикрепить его только к этой детали? Если выбрать вариант замены файла, произойдет следующее:',
      messageBulletOne: '{count} деталь(-и) будут обновлены с помощью нового CAD-файла',
      messageBulletOneForContent: '{count} {contentType} будут обновлены с помощью нового CAD-файла',
      messageBulletTwo: 'Предыдущая версия этого файла будет удалена из файловой системы Documoto',
      tip: 'Совет. Чтобы предотвратить перезапись файлов, можно изменить имя файла, который вы собираетесь прикрепить, перед его импортом.',
      title: 'В Documoto уже существует CAD-файл с таким именем.'
    },
    deleteTitle: 'Вы действительно хотите удалить это 3D-представление?',
    drawMode: {
      hiddenLines: 'Скрытые линии',
      label: 'Режим рисования',
      shaded: 'Закрасить',
      wireframe: 'Каркас',
      wireframeShaded: 'Закрасить каркас'
    },
    explode: 'Развертка',
    failureCreatingBomAssociations: 'Не удалось создать связи между 3D-моделью и спецификацией.',
    fileSizeModal: {
      message: 'Максимально допустимый размер файла в Documoto — 25 мегабайт. Файл, который вы пытаетесь загрузить, превышает максимальный размер и не может быть загружен. Нажмите OK, чтобы продолжить.',
      title: 'Превышен максимальный размер изображения'
    },
    fileSizeModalWarning: {
      message: 'Максимально допустимый размер отдельного файла в Documoto — {size} МБ. Файл, который вы пытаетесь загрузить, превышает максимальный размер и не может быть загружен. Нажмите OK, чтобы продолжить.',
      title: 'Превышен максимальный размер изображения'
    },
    freeTierCurrentCount: 'У вас активно {count} из 15 3D-моделей бесплатного уровня. По достижении лимита вы не сможете публиковать новые страницы с 3D-моделями. Свяжитесь со своим менеджером-консультантом, чтобы обновить подписку.',
    freeTierExceededError: 'Публикация этой страницы с 3D-моделью запрещена.',
    freeTierExceededOption1: 'Свяжитесь со своим менеджером-консультантом, чтобы обновить подписку.',
    freeTierExceededOption2: 'Удалите 3D-модель из черновика страницы, чтобы опубликовать ее.',
    freeTierExceededTitle: 'Вы превысили лимит в 15 активных 3D-моделей',
    illustrationLabel: '2D-вид',
    invalidFile: 'Загружен недопустимый файл',
    mapModelToBom: 'Сопоставить модель со спецификацией',
    modelLabel: '3D-модель',
    modelLabelMobile: '3D',
    noBomPartsMatch3dPartNumbers: 'Не удалось найти детали в спецификации, соответствующие номерам деталей из 3D-модели',
    noPartsMatchRegEx: 'Нет деталей в спецификации, соответствующих регулярному выражению',
    orientation: 'Ориентация',
    orientationAndProjection: {
      back: 'Сзади',
      bottom: 'Снизу',
      front: 'Спереди',
      isometric: 'Изометрическое',
      left: 'Слева',
      orthographic: 'Ортогональное',
      perspective: 'В перспективе',
      projection: 'Проекция',
      right: 'Справа',
      top: 'Сверху'
    },
    partNumberProperty: 'Свойство номера детали',
    partNumberRegex: 'Регулярное выражение для номера детали',
    partNumbersInModel: 'Номера деталей в модели',
    resetCamera: 'Сбросить камеру',
    setAsDefaultView: 'Установить как вид по умолчанию',
    setAsDefaultViewTooltip: 'Установить эту ориентацию и масштаб как начальное представление по умолчанию.',
    slice: {
      label: 'Разрез',
      planeX: 'Режущая плоскость X',
      planeY: 'Режущая плоскость Y',
      planeZ: 'Режущая плоскость Z',
      reset: 'Сброс режущей плоскости',
      section: 'Переключатель сечения режущей плоскости',
      visibility: 'Переключатель видимости режущей плоскости'
    },
    successfullyCreatedBomAssociations: 'Связи между {count} 3D-моделью и спецификацией созданы',
    successfullySavedDefaultView: 'Представление по умолчанию сохранено',
    supportedFilesMessage: 'Documoto поддерживает множество форматов CAD-файлов. Обратитесь в Центр поддержки, если вы не уверены, что ваш формат CAD-файла поддерживается.',
    threeD: '3D',
    toolsLabel: 'Инструменты 3D',
    topAssemblyFilename: 'Имя файла сборки верхнего уровня',
    topAssemblyFilenameInvalid: 'Файл верхнеуровневой сборки отсутствует в списке файлов',
    topAssemblyFilenameRequired: 'Имя файла сборки верхнего уровня является обязательным',
    viewerControls: 'Настройки управления просмотром',
    viewerSettings: 'Настройки 3D-просмотра',
    viewerTitle: 'Просмотр 3D'
  },
  thu: 'Чт',
  thumbnail: 'Миниатюра',
  thumbnailDeleted: 'Миниатюра Успешно Удалена',
  thumbnailDeletedError: 'Не удалось Удалить Миниатюру',
  thumbnailReapplyWarning: 'Система может повторно применить миниатюру, основываясь на контенте медиа. Это может занять несколько минут.',
  thumbnailResizeTooltip: 'Если флажок установлен, измененный размер не должен превышать 500 × 500 пикселей.',
  thumbnailUpdated: 'Миниатюра Успешно Обновлена',
  thumbnailUpdatedError: 'Не удалось Обновить Миниатюру',
  title: 'Заглавие',
  to: 'Адресат',
  toDate: 'Конечная Дата',
  toGetStarted: 'чтобы начать.',
  toastNotifications: 'Всплывающие Уведомления',
  toc: 'Оглавление',
  tocClipBoardSuccessTitle: 'Скопировано в буфер обмена',
  tocClipBoardWarningText: 'ВНИМАНИЕ: Не сохраненные изменения нельзя копировать в ваш буфер обмена',
  tocClipBoardWarningTitle: 'Скопировано в буфер обмена',
  tocDisplayingFirstValues: 'Отображение первых 100 значений. Используйте фильтр, чтобы увидеть больше.',
  tocDuplicateWarningText: 'В главе была обнаружена страница-дубликат. Дубликат был удален.',
  tocEmptyMessage: 'Похоже, вы еще не создали Оглавление',
  tocMissingChapterName: 'Отсутствует Название Главы',
  tocModalTableCaption: 'Редактор Тегов',
  tocNothingSelected: 'Ничего Не выбрано',
  tocOpenEditor: 'Открыть Редактор',
  tocSaveRequired: 'Необходимо выполнить сохранение, прежде чем редактировать главу',
  tocState: 'Исходное Состояние Оглавления',
  tocThumbnailDeleteFailTitle: 'Не удалось Удалить Миниатюру',
  tocThumbnailDeleteSuccessTitle: 'Миниатюра Успешно Удалена',
  tocThumbnailUploadFailTitle: 'Не удалось Загрузить Миниатюру',
  tocThumbnailUploadSuccessTitle: 'Миниатюра Успешно Загружена',
  tocTranslationMessage: 'Имя и опциональное описание этой главы',
  tocUntitledPage: 'Страница без названия',
  togglePage: 'Переключатель Страниц',
  tooManySelections: 'Список превышает ограничения выборки ({limit})',
  top: 'Верх',
  total: 'Сумма',
  totalItems: 'Сумма Наименований',
  translation: 'Перевод | Переводы',
  translationHelpTextItem: 'Имя и опциональное описание этого(й) {item}',
  'true': 'Да',
  tryAgain: 'Пожалуйста, попробуйте снова.',
  trySearchingToc: 'Попробуйте ввести любое слово, которое видите или помните — список мгновенно сократится. Экран не изменится, пока вы не нажмете на один из результатов.',
  tryThis: 'Попробуйте это:',
  tue: 'Вт',
  turkishDescription: 'Описание На Турецком',
  turkishName: 'Название На Турецком',
  twoSided: 'Двусторонняя',
  type: 'Тип | Типы',
  typeAtLeastTwoChars: 'Чтобы увидеть список совпадений, введите не менее двух символов.',
  typeSearchCriteriaAlreadySet: 'Удалите выбранный критерий поиска «Тип», чтобы применить изменения.',
  typeToConfirm: 'Введите {value} для подтверждения',
  typography: 'Типография',
  ukraineDescription: 'Описание На Украинском',
  ukraineName: 'Название На Украинском',
  unableToRetrieveResults: 'Невозможно получить результаты для вашего запроса/поиска',
  unauthorized: 'Несанкционированный',
  unknownError: 'Неизвестная ошибка. Пожалуйста, обратитесь в службу поддержки Documoto по адресу support{\'@\'}documoto.com.',
  unknownInput: 'Неизвестный тип ввода:',
  unknownPart: 'Неизвестная Деталь',
  unknownType: 'Неизвестный тип',
  unsavedAPIKeyWarning: 'В случае невыполнения Возврата Ключ API будет утерян',
  unsavedChanges: 'У вас имеются несохраненные изменения. Продолжить?',
  unsavedChangesWarning: 'Ваши изменения будут утрачены, если их не сохранить.',
  unsavedWidgetKeyWarning: 'Если вы не вернетесь, ваш ключ виджета будет утерян.',
  unsupportedBrowserMessage: 'Эта программа использует новейшие технологии. Они делают приложение более быстрым и удобным в работе. К сожалению, ваш браузер не поддерживает эти технологии.',
  untitledOrg: 'Организация без названия',
  unverified: 'Не подтверждено',
  uom: 'Ед. изм.',
  update: 'Обновить',
  updateFailed: 'Не удалось обновить ',
  updateIndex: 'Обновить Указатель',
  updatePassword: 'Обновить Пароль',
  updatePasswordMessage: 'Пароль успешно обновлен',
  updatePasswordPending: 'Ожидается сохранение после обновления пароля.',
  updated: 'Обновлено',
  upgradeBrowser: 'Обновите свой браузер.',
  upload: 'Загрузить',
  uploadComplete: 'Загрузка Завершена',
  uploadFileSizeLimitExceeded: 'Размер файла превышает допустимый для просмотра в приложении.',
  uploadInProgress: 'Проходит Загрузка',
  uponSavingDisabledTenant: 'Если сохранить эту страницу и включить эту настройку, произойдет следующее:',
  uponSavingThisLicense: 'Сохранив эту страницу с данной настройкой, вы ДОЛЖНЫ ВЫПОЛНИТЬ СЛЕДУЮЩИЕ ДЕЙСТВИЯ:',
  upperBound: 'Максимальное Значение',
  usCurrency: 'дол. США',
  useDefaultCartColumns: 'Используйте Колонки Корзины По умолчанию',
  useDefaultPartsListColumns: 'Используйте Колонки Списка Деталей По умолчанию',
  useSequentialPageNumbering: 'Использовать Последовательную Нумерацию Страниц',
  useSniForSsoMetadataRetrieval: 'Использовать SNI для получения метаданных SSO',
  user: 'Пользователь',
  userAddress: 'Адрес Пользователя | Адреса Пользователя',
  userCount: 'Количество Пользователей',
  userEditable: 'Редактирование Пользователем разрешено',
  userExpirationDate: 'Срок действия для пользователя',
  userExpirationDateInvalid: 'Необходимо указать срок действия для пользователя',
  userGroup: 'Группа Пользователей | Группы Пользователей',
  userGroupEmpty: 'Поле Групп Пользователя не должно быть пустым',
  userGroupType: 'Тип группы пользователей ',
  userGroupUniqueMessage: 'Это имя участника должно отличаться от других имен в Группе Пользователей',
  userGroupUsers: 'Пользователи в Группе Пользователей',
  userSettings: 'Параметры пользователя',
  userVerificationEmailBody: 'Текст письма для подтверждения пользователя',
  userVerificationEmailFieldsValidation: 'Поля письма для подтверждения пользователя должны быть либо оба заполнены, либо оба пусты',
  userVerificationEmailSubject: 'Тема письма для подтверждения пользователя',
  username: 'Имя пользователя',
  usernameEmpty: 'Имя пользователя должно быть заполнено',
  users: 'Пользователи',
  usersWillReceiveAnUnauthorizedError: 'При попытке войти в учетную запись участника пользователи получат ошибку «Несанкционированный».',
  validate: 'Проверить',
  validateTenantDirectories: {
    buttonLabel: 'Проверить каталоги содержимого',
    error: 'Не удалось проверить каталоги',
    success: 'Каталоги участников проверены'
  },
  validationMessage: 'Сообщение Проверки | Сообщения Проверки',
  value: 'Значение',
  valueGteError: 'Значение должно быть меньше или равно {max}',
  valueLteError: 'Значение должно быть больше или равно {min}',
  variantSKU: 'Вариант SKU',
  vendorName: 'Поставщик услуг',
  verificationEmailRequested: 'Письмо для подтверждения будет отправлено при сохранении.',
  verificationEmailSent: 'Письмо для подтверждения отправлено.  Пароль не установлен.',
  verified: 'Подтверждено',
  verifyPassword: 'Подтвердить Пароль',
  verifying: 'Подтверждение…',
  version: 'Версия',
  vertical: 'Вертикальный',
  video: 'Видео | Видео',
  view: 'Просмотр',
  viewAll: 'Просмотреть все',
  viewAllPagesAndBooks: 'Просмотреть все страницы и книги',
  viewAllResults: 'Просмотреть все результаты',
  viewBooks: 'Просмотреть книги',
  viewModeList: 'Список',
  viewModeTable: 'Таблица',
  viewMore: 'Увидеть больше',
  viewPages: 'Просмотреть страницы',
  viewWhereUsed: 'Посмотреть, где используется',
  views: 'Представления',
  visibility: 'Видимость',
  visibilityDescription: 'Кто может просматривать {entity}',
  visible: 'Видимый',
  waitForUpload: 'Пожалуйста, подождите, пока закончится загрузка.',
  watermark: 'Водяной знак',
  watermarkFont: 'Шрифт водяного знака',
  watermarkOpacityPercentage: 'Непрозрачность водяного знака (в %)',
  watermarkOrientation: 'Ориентация водяного знака',
  watermarkSaveFailed: 'Не удалось сохранить водяной знак.',
  watermarkSaved: 'Водяной знак сохранен',
  watermarkSelectionRequired: 'Необходимо ввести данные в поля «Имя пользователя» и «Выбор текста».',
  watermarkText: 'Текст водяного знака',
  wed: 'Ср',
  whereUsed: 'Где Используется',
  whereUsedCountInSearchBar: 'Количество в использовании (в строке поиска)',
  whoCanViewComment: 'Кто может видеть этот комментарий?',
  wholesale: 'Опт',
  wholesalePrice: 'Оптовая Цена',
  wholesaleTotal: 'Суммарная Оптовая Цена',
  widget: 'Виджет',
  widgetAuthHeader: 'Значение авторизации виджета',
  widgetErrorConfig: 'Не удалось инициализировать виджет из-за некорректной конфигурации',
  widgetErrorInit: 'Не удалось инициализировать виджет Documoto',
  widgetErrorLocation: 'Не удалось найти указанный контент внутри виджета',
  widgetErrorMultipleLocations: 'Для указанного контента найдено несколько путей',
  widgetKey: 'Ключ виджета | Ключи виджетов',
  widgetKeyAdmin: 'Администратор ключа виджета',
  widgetKeyCopied: 'Значение авторизации виджета скопировано в буфер обмена',
  widgetKeyDeleteMsg: 'Удаление ключа виджета отключит его использование',
  widgetKeyDeleted: 'Ключ виджета удален',
  widgetKeyDeletedError: 'При удалении ключа виджета возникла ошибка',
  widgetKeyManager: 'Управляющий ключом виджета',
  widgetKeyNameEmpty: 'Укажите уникальное имя. Оно будет использоваться, помимо прочего, для целей отчетности и ведения журнала в качестве имени пользователя при любой активности виджета.',
  widgetKeyRegenError: 'При повторной генерации ключа виджета возникла ошибка',
  widgetKeyRegenMsg: 'Повторная генерация ключа виджета может привести к отключению существующих интеграций',
  widgetKeyRegenTitle: 'Повторно сгенерировать ключ виджета?',
  widgetKeySaved: 'Ключ виджета сохранен',
  widgetPermissions: 'Для пользователей виджетов предусмотрен только режим чтения, а доступом к функциям можно управлять с помощью конфигурации на уровне виджета. Разрешения для стандартной группы пользователей не распространяются на пользователей виджетов, в отличии от прав доступа к медийной категории. Настройте управление доступом к медийной категории.',
  widgetRefreshErrorMsg: 'Обновите страницу, чтобы просмотреть запрашиваемое содержимое',
  widgetUserGroup: 'Группа пользователей виджетов',
  widgetUserGroupDeleteMsg: 'Не удалось удалить группу виджетов с пользователями',
  willBeAffected: 'будет затронут(о).',
  willBeDeleted: '{content} будет удален(о).',
  willBeInsertedIntoItem: '{name} будет вставлено в {item}',
  willBeUpdated: 'будет обновлено.',
  year: 'Год',
  yourEmailAddress: 'Ваш адрес электронной почты',
  zipCode: 'Почтовый Индекс',
  zoomHotpointToCanvas: 'Увеличить Ссылку-якорь до размера Холста',
  zoomIn: 'Увеличение',
  zoomOut: 'Уменьшение'
};
/* eslint-enable max-len */
